import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import 'moment-timezone'
import { AppTaskCreationConfirmation } from 'components/AppKanbanBoard/AppTaskCreationConfirmation/AppTaskCreationConfirmation.component'
import { AppModalBox } from 'components/Common/AppModalBox/AppModalBox.component'
import AppCrossIcon from 'components/Common/AppSvgIcons/AppModalCrossIcon'
import { AppTask } from 'components/AppKanbanBoard/AppTask/AppTask.component'
import { useKanbanBoardData } from 'components/AppKanbanBoard/AppHook/AppKanbanBoard.hook'
import { useGetBusinessProfile } from 'appHooks/useGetBusinessProfile'

import {
  BusinessGoalDateFilter,
  UserTask,
  UserTaskQuickFilter,
  UserTaskSource,
  useAddPrivateNoteMutation,
  useUpdatePrivateNoteMutation,
  useDeletePrivateNoteMutation,
  useGetUserMeetingTasksQuery,
  useGetAllInvitedUsersQuery,
  useDeleteUserTaskMutation,
  UserFile,
  useCancelUserCalendarEventMutation,
  useUpdateUserCalendarEventMutation,
  useUpdateTranscriptSummaryMutation,
  useRequestMeetingMutation,
  useRescheduleUserCalendarEventMutation,
  useGetAllTagUsersQuery,
} from '__generated__/api-types-and-hooks'
import { addDays } from 'date-fns'
import { useGetAdvisorAssignedTasks } from 'appHooks/useGetAdvisorAssignedTasks'
import { ITaskSummaryItem } from 'components/AppDashboard/interfaces'

import { checkAvailability, getRoleFromPath, getUserRole, replaceTerm } from 'utils/helper'
import {
  getAdvisorProfileAction,
  getBoAdvisorAction,
  getUserAvailabilityAction,
  getUserAvailabilityHoursAction,
  updateMeetingStepperAction,
} from 'store/actions/calendar'

import { categoryType } from 'appConfig/data'
import { AppEmojiPicker } from '../../../AppShared/AppEmojiPicker/AppEmojiPicker.component'
import {
  ACTION_TYPE,
  availabilityStatus,
  FORM,
  MEETING_STEPPER,
  ROLES,
  timeDurationAvailabilityOptions,
  USER_ROLES,
} from 'config'
import MeetingConfirmation from 'components/Calendar/Meetings/MeetingConfirmation'
import ModalBox from 'components/Common/ModalBox'
import MeetingCancelIcon from 'components/Common/SvgIcons/MeetingCancelIcon'
import { AppFileUploader } from 'components/AppFileUploader/AppFileUploader.component'
import { AppFileIconDouble } from 'components/Common/AppSvgIcons/AppFileIconDouble'
import { AppTaskFileCard } from 'components/AppKanbanBoard/AppTask/AppTaskFileCard/AppTaskFileCard.component'
import { RootState } from 'App'

import { AppFC, UserBasicInfo } from 'types'
import { useDispatch, useSelector } from 'react-redux'
import AppInvitationSuccessModal from './AppInviteConfirmation'

import { Tooltip } from 'react-tooltip'

import { CrossIcon, DropDownIcon, SelectFieldCancelIcon } from 'components/Common/SvgIcons'
import { isMobileOnly } from 'mobile-device-detect'
import {
  CalendarTitle,
  CalendarWrapper,
  CheckboxWrapper,
  IconWithLabel,
  InputFieldsWrapper,
  MeetingDuration,
  MeetingDurationTitle,
  NoSlotLabel,
  TimeDuration,
} from 'components/Calendar/style'
import Tile from 'components/Common/Tile'
import { isEmpty, sortBy, toNumber } from 'lodash'
import GradientCircleNotchIcon from 'components/Common/SvgIcons/GradientCircleNotchIcon'
import draftToHtml from 'draftjs-to-html'
import Button from 'components/Common/Button'
import redirectTo from 'utils/redirectTo'
import { useFlashParams } from 'hooks/useFlashParams'
import { Controller, useForm } from 'react-hook-form'
import CheckBoxField from 'components/Common/CheckBoxField'
import { yupResolver } from '@hookform/resolvers/yup'
import { meetingsSchema } from 'components/Calendar/Meetings/validations'
import Calendar from 'react-calendar'
import hookForms from 'utils/hookForms'
import CircleNotchIcon from 'components/Common/SvgIcons/CircleNotchIcon'
import { getAdvisorDashboardAction } from 'store/actions/clients'
import PaginatedSlots from 'components/Calendar/PaginatedSlots'
import SlotsSelector from 'components/Calendar/SlotsSelector'
import { getTimeZoneDisplayRepresentation } from 'utils/dates'

import Select, { components, MultiValueRemoveProps, CSSObjectWithLabel } from 'react-select'
import MeetingDetails from 'components/Calendar/Meetings/MeetingDetails'
import { convertToRaw, EditorState } from 'draft-js'
import CalendarIcon from 'components/Common/SvgIcons/CalendarIcon'
import ClockIcon from 'components/Common/SvgIcons/ClockIcon'
import { MeetingConfirmationContainer } from 'pages/Owner/container'
import { Document, Packer, Paragraph, TextRun } from 'docx'
import { saveAs } from 'file-saver'

const MultiValueRemove: AppFC<MultiValueRemoveProps<any>> = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      {isMobileOnly ? (
        <CrossIcon className="h-[14px] w-[14px]" />
      ) : (
        <SelectFieldCancelIcon className="fill-black-light" />
      )}
    </components.MultiValueRemove>
  )
}
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <DropDownIcon
        className={`${
          props.isDisabled
            ? !props.hasValue
              ? 'fill-primary-disabledText'
              : 'fill-grey-darkest1x'
            : 'fill-primary'
        } hover:fill-primary-brand focus:fill-primary-active active:fill-primary-active h-5`}
      />
    </components.DropdownIndicator>
  )
}

const UpcomingMeeting = ({
  meetingDataLoading,
  meeting,
  getTackleMeetingEventsAction,
  filter,
  status,
  user,
  searchResults = '',
  userAvailabilityList,
  userAvailableMeetingLocation,
  badge,
  onMeetingActionSuccess,
}) => {
  useParams()
  const dispatch = useDispatch()
  const { flashParams, removeFlashParams } = useFlashParams<{
    availabilityConnectionError: string
  }>()
  const { clientId } = useParams()
  const [showDropdown] = useState(false)
  const [previousMettingId, setPreviousMettingId] = useState('')
  const [openUpcomingDropdownIds, setOpenUpcomingDropdownIds] = useState({})
  const [showModal, setShowModal] = useState(false)

  const [showDetails, setShowDetails] = useState(false)
  const [panelOpen, setPanelOpen] = useState(false)
  const [openNote, setOpenNote] = useState(false)
  const [openThread, setOpenThread] = useState(false)

  const [showAddTaskModal, setShowAddTaskModal] = useState(false)
  const [showAddTaskSuccessModal, setShowAddTaskSuccessModal] = useState(false)
  const [isUpdateTaskSuccess, setIsUpdateTaskSuccess] = useState(false)

  const [showAddTaskErrorModal, setShowAddTaskErrorModal] = useState(false)
  const [createdUserTask, setCreatedUserTask] = useState<UserTask>({})

  const [showTaskDetails, setShowTaskDetails] = useState(false)
  const [selectedTask, setSelectedTask] = useState<ITaskSummaryItem | null>(null)

  const [showTextareaIndex, setShowTextareaIndex] = useState(null)
  const [noteText, setNoteText] = useState<string>('')
  let [privateNote, setPrivateNote] = useState<string>('')
  const textAreaRef = useRef<HTMLTextAreaElement>(null)
  const privateNoteRef = useRef<HTMLTextAreaElement>(null)
  const summaryRef = useRef<HTMLTextAreaElement>(null)
  const emojiPickerRef = useRef<HTMLDivElement>(null)
  const emojiPickerRef2 = useRef<HTMLDivElement>(null)
  const emojiPickerRef3 = useRef<HTMLDivElement>(null)
  const mentionPickerRef = useRef<HTMLDivElement>(null)
  const mentionPickerAddNoteRef = useRef<HTMLDivElement>(null)
  const mentionPickerUpdateNoteRef = useRef<HTMLDivElement>(null)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [showEmojiPicker2, setShowEmojiPicker2] = useState(false)
  const [showEmojiPicker3, setShowEmojiPicker3] = useState(false)

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [deletePayload, setDeletePayload] = useState<{ data: string; id: string } | null>(null)
  const [showDeleteActionItemConfirm, setShowDeleteActionItemConfirm] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [meetingPayload, setDeleteMeetinghPayload] = useState<{
    eventId: string
    eventType: string
    id: string
  } | null>(null)

  const [selectedMeeting, setSelectedMeeting] = useState<any>(null)
  type InvitedUser = {
    lastName: string
    firstName: string
    email: string
  }
  const [invitedEmails, setInvitedEmails] = useState<InvitedUser[]>([])
  const [attendee, setAttendee] = useState<any>([])
  const [emailInput, setEmailInput] = useState('')
  const [cancelMeetingModal, setCancelMeetingModal] = useState<boolean>(false)
  const [confirmMeetingModal, setConfirmMeetingModal] = useState<boolean>(false)
  const [deleteActionPayload, setDeleteActionPayload] = useState<{
    data: string | null | undefined
    id: string
  } | null>(null)
  const [showTranscript, setShowTranscript] = useState(false)
  const [downloadDoc, setDownloadDoc] = useState<{ text?: string; start: string } | null>(null)
  const [privateNoteFiles, setPrivateNoteFiles] = useState<UserFile[]>([])
  const [playsFiles, setPlaysFiles] = useState<UserFile[]>([])

  const [inviteMeetingId, setInviteMeetingId] = useState<any>([])
  const [inviteMeetingData, setInviteMeetingData] = useState<any>([])
  const [rescheduleAppointId, setRescheduleAppointId] = useState<any>([])
  const [requestId, setRequestId] = useState<any>([])
  const { userId, tenantId, taskPlan, goalEndDate, assigneeOptions } = useKanbanBoardData({
    filter,
  })

  const previousMettingById = useMemo(() => {
    return meeting?.find((meet) => meet?.id === previousMettingId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting, previousMettingId, filter])

  const [data, setData] = useState(previousMettingById?.transcriptSummary)
  const [showMentionList, setShowMentionList] = useState(false)

  // Read meetingId from deep link and set state. Auto-open details if filter indicates past.
  useEffect(() => {
    try {
      const url = new URL(window.location.href)
      const filterParam = url.searchParams.get('filter') || ''
      // Handle case where someone accidentally uses ?filter=past?meetingId=... by normalizing
      const rawSearch = window.location.search
      let meetingIdParam = url.searchParams.get('meetingId')
      if (!meetingIdParam && /meetingId=/.test(rawSearch)) {
        const m = rawSearch.match(/meetingId=([^&]+)/)
        if (m && m[1]) meetingIdParam = decodeURIComponent(m[1])
      }

      // Always set previousMettingId from URL if present
      if (meetingIdParam) {
        setPreviousMettingId(meetingIdParam)
      }

      // Open details automatically when deep-linking to past
      if (filterParam.includes('past') && meetingIdParam) {
        setShowDetails(true)
        if (typeof status === 'function') status('closed')
      }
    } catch (e) {
      // no-op
    }
    // run only once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [showMentionListAddNote, setShowMentionListAddNote] = useState(false)
  const [showMentionListUpdateNote, setShowMentionListUpdateNote] = useState(false)
  const [fileDeleteSuccess, setFileDeleteSuccess] = useState<boolean | null>(null)

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target as Node)) {
        setShowEmojiPicker(false)
      }
      if (emojiPickerRef2.current && !emojiPickerRef2.current.contains(event.target as Node)) {
        setShowEmojiPicker2(false)
      }
      if (emojiPickerRef3.current && !emojiPickerRef3.current.contains(event.target as Node)) {
        setShowEmojiPicker3(false)
      }
      if (
        mentionPickerAddNoteRef.current &&
        !mentionPickerAddNoteRef.current.contains(event.target as Node)
      ) {
        setShowMentionListAddNote(false)
      }

      if (
        mentionPickerUpdateNoteRef.current &&
        !mentionPickerUpdateNoteRef.current.contains(event.target as Node)
      ) {
        setShowMentionListUpdateNote(false)
      }
    }

    if (showEmojiPicker) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    if (showEmojiPicker2) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    if (showEmojiPicker3) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    if (showMentionList) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    if (showMentionListAddNote) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    if (showMentionListUpdateNote) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    showEmojiPicker,
    showEmojiPicker2,
    showEmojiPicker3,
    showMentionList,
    showMentionListAddNote,
    showMentionListUpdateNote,
  ])

  const onEmojiClick = (emojiData: any) => {
    // Insert emoji at cursor position or at the end if no cursor
    const textarea = textAreaRef.current
    if (textarea) {
      const start = textarea.selectionStart
      const mentionRegex = /<mention id="[^"]*">[^<]*<\/mention>/g
      const matches = textarea?.value.match(mentionRegex)
      const matchedBetween = matches?.filter((match, index) => {
        const startIndex = textarea?.value.indexOf(match)

        const buffer = index === 0 ? 0 : 19
        return startIndex + buffer < start
      })
      const totalLength = matchedBetween?.reduce((acc, match) => acc + match.length, 0) ?? 0
      let totalLengthWithDifferent = totalLength
      if (matchedBetween?.length && matchedBetween?.length >= 1) {
        totalLengthWithDifferent -= matchedBetween?.length * 10
      }
      const newValue =
        textarea?.value.slice(0, start + totalLengthWithDifferent) +
        emojiData.emoji +
        textarea?.value.slice(start + totalLengthWithDifferent)
      setNoteText(newValue)

      // Reset cursor position after emoji insertion
      setTimeout(() => {
        textarea.focus()
        const newPosition = start + emojiData.emoji.length
        textarea.setSelectionRange(newPosition, newPosition)
      }, 0)
    } else {
      // If no cursor position, append to end
      setNoteText(noteText + emojiData.emoji)
    }
    setShowEmojiPicker(false)
  }

  const onEmojiClick2 = (emojiData: any) => {
    const textarea = privateNoteRef.current
    if (textarea) {
      const start = textarea.selectionStart
      const mentionRegex = /<mention id="[^"]*">[^<]*<\/mention>/g
      const matches = textarea?.value.match(mentionRegex)
      const matchedBetween = matches?.filter((match, index) => {
        const startIndex = textarea?.value.indexOf(match)

        const buffer = index === 0 ? 0 : 19
        return startIndex + buffer < start
      })
      const totalLength = matchedBetween?.reduce((acc, match) => acc + match.length, 0) ?? 0
      let totalLengthWithDifferent = totalLength
      if (matchedBetween?.length && matchedBetween?.length >= 1) {
        totalLengthWithDifferent -= matchedBetween?.length * 10
      }
      const newValue =
        textarea?.value.slice(0, start + totalLengthWithDifferent) +
        emojiData.emoji +
        textarea?.value.slice(start + totalLengthWithDifferent)
      setPrivateNote(newValue)

      // Reset cursor position after emoji insertion
      setTimeout(() => {
        textarea.focus()
        const newPosition = start + emojiData.emoji.length
        textarea.setSelectionRange(newPosition, newPosition)
      }, 0)
    } else {
      // If no cursor position, append to end
      setPrivateNote(privateNote + emojiData.emoji)
    }
    setShowEmojiPicker2(false)
  }

  const onEmojiClick3 = (emojiData: any) => {
    const textarea = summaryRef.current
    if (textarea) {
      const start = textarea.selectionStart
      const mentionRegex = /<mention id="[^"]*">[^<]*<\/mention>/g
      const matches = textarea?.value.match(mentionRegex)
      const matchedBetween = matches?.filter((match, index) => {
        const startIndex = textarea?.value.indexOf(match)

        const buffer = index === 0 ? 0 : 19
        return startIndex + buffer < start
      })
      const totalLength = matchedBetween?.reduce((acc, match) => acc + match.length, 0) ?? 0
      let totalLengthWithDifferent = totalLength
      if (matchedBetween?.length && matchedBetween?.length >= 1) {
        totalLengthWithDifferent -= matchedBetween?.length * 10
      }
      const newValue =
        textarea?.value.slice(0, start + totalLengthWithDifferent) +
        emojiData.emoji +
        textarea?.value.slice(start + totalLengthWithDifferent)
      setData(newValue)

      // Reset cursor position after emoji insertion
      setTimeout(() => {
        textarea.focus()
        const newPosition = start + emojiData.emoji.length
        textarea.setSelectionRange(newPosition, newPosition)
      }, 0)
    } else {
      // If no cursor position, append to end
      setData(data + emojiData.emoji)
    }
    setShowEmojiPicker3(false)
  }

  function timeAgo(input: string | Date): string {
    const now = new Date()
    const date = new Date(input)
    const diffMs = now.getTime() - date.getTime()

    const seconds = Math.floor(diffMs / 1000)
    const minutes = Math.floor(diffMs / (1000 * 60))
    const hours = Math.floor(diffMs / (1000 * 60 * 60))
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24))

    if (seconds < 60) {
      return `${seconds} sec ago`
    } else if (minutes < 60) {
      return `${minutes} min ago`
    } else if (hours < 24) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`
    } else if (days < 7) {
      return `${days} day${days > 1 ? 's' : ''} ago`
    } else {
      return date.toLocaleDateString() // e.g., "5/1/2025"
    }
  }
  const handleAddTextarea = (index, content) => {
    setShowTextareaIndex(index)
    setNoteText(content)
  }
  const {
    hoursSpentPerDay,
    advisorsData,
    userAvatar,
    userFirstName,
    userLastName,
    userName,
    logo,
  } = useGetBusinessProfile({})

  let clientID = user?.roles[0] === 'BUSINESS_OWNER' ? user?.id : previousMettingById?.advisorId

  const { data: meetingData, refetch: refetchMeetingTask } = useGetUserMeetingTasksQuery({
    input: {
      userId: clientID ?? userId,
      tenantId,
      filter: { quickFilter: UserTaskQuickFilter.AllTasks },
      meetingId: previousMettingById?.id,
    },
  })

  const { data: inviteData } = useGetAllInvitedUsersQuery({
    input: {
      tenantId,
      userId: clientID ?? userId,
    },
  })
  const { data: taggedData } = useGetAllTagUsersQuery({
    input: {
      tenantId,
      userId: clientId,
    },
  })
  type MentionUser = {
    id: string
    firstName: string
    lastName: string
    email?: string
    roles?: Array<any>
  }
  type MentionUserInvite = {
    id: string
    firstName: string
    lastName: string
    email?: string
    roles?: Array<any>
  }
  const [filteredUsers, setFilteredUsers] = useState<MentionUser[]>([])
  const [allUsers, setAllUsers] = useState<MentionUser[]>([])
  const [allInviteUsers, setAllInviteUsers] = useState<MentionUserInvite[]>([])
  const [cursorPos, setCursorPos] = useState(0)

  const isUserBusinessOwner = (): boolean => {
    const roles = user?.roles ?? []
    return roles[0] === 'BUSINESS_OWNER'
  }

  const parsedData = useRef<any[]>([])
  const parsedInviteData = useRef<any[]>([])

  useEffect(() => {
    const raw = inviteData?.getAllInvitedUsers ?? []

    // Step 1: Filter valid users (with required fields)
    const cleanedRaw: MentionUserInvite[] = raw
      .filter((user): user is NonNullable<typeof user> => !!user)
      .filter(
        (user) =>
          typeof user.id === 'string' &&
          typeof user.firstName === 'string' &&
          typeof user.lastName === 'string'
      )
      .map((user) => ({
        id: user.id!,
        firstName: user.firstName!,
        lastName: user.lastName!,
        email: user.email ?? undefined,
        roles: user.roles ?? [],
      }))

    // Step 3: Set refs and state

    parsedInviteData.current = cleanedRaw

    setAllInviteUsers(cleanedRaw)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteData])

  useEffect(() => {
    const tagUser = taggedData?.getAllTagUsers ?? []

    const cleanedRaw: MentionUserInvite[] = tagUser
      .filter((user): user is NonNullable<typeof user> => !!user)
      .filter(
        (user) =>
          typeof user.id === 'string' &&
          typeof user.firstName === 'string' &&
          typeof user.lastName === 'string'
      )
      .map((user) => ({
        id: user.id!,
        firstName: user.firstName!,
        lastName: user.lastName!,
        email: user.email ?? undefined,
        roles: user.roles ?? [],
      }))

    parsedData.current = cleanedRaw
    setAllUsers(cleanedRaw)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taggedData])

  const handleChange = (e) => {
    const value = e.target.value
    const pos = e.target.selectionStart
    setCursorPos(pos)

    const sliced = value.slice(0, pos)
    // detect @mention being typed
    const match = !isBusinessOwner && sliced.match(/@([\w]*)$/)

    if (match) {
      const query = match[1]
      const filtered = allUsers.filter((user) =>
        `${user.firstName} ${user.lastName}`.toLowerCase().includes(query.toLowerCase())
      )
      setFilteredUsers(filtered)
      setShowMentionList(true)
    } else {
      setShowMentionList(false)
    }

    setData(value)
  }

  const handleAtClick = () => {
    const before = data.slice(0, cursorPos)
    const after = data.slice(cursorPos)
    const newText = before + after

    setData(newText)
    const newCursor = before.length + 1
    setCursorPos(newCursor)
    setFilteredUsers(allUsers)
    setShowMentionList(true)

    setTimeout(() => {
      if (summaryRef.current) {
        summaryRef.current.focus()
        summaryRef.current.setSelectionRange(newCursor, newCursor)
      }
    }, 0)
  }

  const handleUserSelect = (user) => {
    // Insert with @ + compact name (remove spaces)
    const mentionLabel = `@${user.firstName}${user.lastName.replace(/\s+/g, '')}`

    // Remove partial "@word" already typed before cursor
    const before = data.slice(0, cursorPos).replace(/@([\w]*)$/, '')
    const after = data.slice(cursorPos)

    const newText = before + mentionLabel + ' ' + after
    const newCursorPos = (before + mentionLabel + ' ').length

    setData(newText)
    setCursorPos(newCursorPos)
    setShowMentionList(false)

    setTimeout(() => {
      if (summaryRef.current) {
        summaryRef.current.focus()
        summaryRef.current.setSelectionRange(newCursorPos, newCursorPos)
      }
    }, 0)
  }
  const [taggedId, setTaggedId] = useState<string[]>([])

  const handleChangeAddNote = (e) => {
    const value = e.target.value
    const pos = e.target.selectionStart
    setCursorPos(pos)

    const sliced = value.slice(0, pos)
    // detect "@word"
    const match = !isBusinessOwner && sliced.match(/@([\w]*)$/)

    if (match) {
      const query = match[1]

      const filtered = allUsers.filter((user) =>
        `${user.firstName} ${user.lastName}`.toLowerCase().includes(query.toLowerCase())
      )
      setFilteredUsers(filtered)
      setShowMentionListAddNote(true)
    } else {
      setShowMentionListAddNote(false)
    }

    setPrivateNote(value)
  }

  const handleAtClickAddNote = () => {
    const before = privateNote.slice(0, cursorPos)
    const after = privateNote.slice(cursorPos)
    const newText = before + after

    setPrivateNote(newText)
    const newCursor = before.length + 1
    setCursorPos(newCursor)

    setFilteredUsers(allUsers)
    setShowMentionListAddNote(true)

    setTimeout(() => {
      if (privateNoteRef.current) {
        privateNoteRef.current.focus()
        privateNoteRef.current.setSelectionRange(newCursor, newCursor)
      }
    }, 0)
  }

  const handleUserSelectAddNote = (user) => {
    // Always insert with @
    const mentionLabel = `@${user.firstName}${user.lastName.replace(/\s+/g, '')}`

    // Remove the partial typed word after "@"
    const before = privateNote.slice(0, cursorPos).replace(/@([\w]*)$/, '')
    const after = privateNote.slice(cursorPos)

    const newText = before + mentionLabel + ' ' + after
    const newCursorPos = (before + mentionLabel + ' ').length

    setPrivateNote(newText)
    setCursorPos(newCursorPos)
    setShowMentionListAddNote(false)

    // store tagged user ID
    setTaggedId((prev) => (user.id && !prev.includes(user.id) ? [...prev, user.id] : prev))

    setTimeout(() => {
      if (privateNoteRef.current) {
        privateNoteRef.current.focus()
        privateNoteRef.current.setSelectionRange(newCursorPos, newCursorPos)
      }
    }, 0)
  }

  const handleChangeUpdateNote = (e) => {
    const value = e.target.value
    const pos = e.target.selectionStart
    setCursorPos(pos)

    const sliced = value.slice(0, pos)
    const match = !isBusinessOwner && sliced.match(/@([\w]*)$/)

    if (match) {
      const query = match[1] // text after @
      const filtered = allUsers.filter((user) =>
        `${user.firstName} ${user.lastName}`.toLowerCase().includes(query.toLowerCase())
      )
      setFilteredUsers(filtered)
      setShowMentionListUpdateNote(true)
    } else {
      setShowMentionListUpdateNote(false)
    }

    setNoteText(value)
  }

  const handleAtClickUpdateNote = () => {
    const before = noteText.slice(0, cursorPos)
    const after = noteText.slice(cursorPos)
    const newText = before + after
    setNoteText(newText)
    const newCursor = before.length + 1
    setCursorPos(newCursor)
    setFilteredUsers(allUsers)
    setShowMentionListUpdateNote(true)

    setTimeout(() => {
      if (textAreaRef.current) {
        textAreaRef.current.focus()
        textAreaRef.current.setSelectionRange(newCursor, newCursor)
      }
    }, 0)
  }

  const handleUserSelectUpdateNote = (user) => {
    const username = `${user.firstName}${user.lastName}`.toLowerCase()
    const mentionLabel = `@${username}` // what we insert into text

    //  remove the @word currently being typed
    const before = noteText.slice(0, cursorPos).replace(/@[\w]*$/, '')
    const after = noteText.slice(cursorPos)

    const newText = before + mentionLabel + ' ' + after
    const newCursorPos = (before + mentionLabel + ' ').length

    setNoteText(newText)
    setCursorPos(newCursorPos)
    setShowMentionListUpdateNote(false)

    // track user id for backend
    setTaggedId((prev) => (user.id && !prev.includes(user.id) ? [...prev, user.id] : prev))

    setTimeout(() => {
      if (textAreaRef.current) {
        textAreaRef.current.focus()
        textAreaRef.current.setSelectionRange(newCursorPos, newCursorPos)
      }
    }, 0)
  }

  useEffect(() => {
    if (showAddTaskSuccessModal) {
      refetchMeetingTask()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAddTaskSuccessModal])

  useEffect(() => {
    if (showAddTaskSuccessModal && selectedTask?.taskId) {
      refetchMeetingTask().then((res) => {
        const updatedTasks = res?.data?.getUserMeetingTasks
        if (updatedTasks?.length) {
          const updatedTask = updatedTasks.find((task) => task.taskId === selectedTask.taskId)
          if (updatedTask) {
            setSelectedTask(updatedTask as ITaskSummaryItem)
          }
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAddTaskSuccessModal])

  useEffect(() => {
    if (fileDeleteSuccess === true && selectedTask?.taskId) {
      refetchMeetingTask().then((res) => {
        const updatedTasks = res?.data?.getUserMeetingTasks
        if (updatedTasks?.length) {
          const updatedTask = updatedTasks.find((task) => task.taskId === selectedTask.taskId)
          if (updatedTask) {
            setSelectedTask(updatedTask as ITaskSummaryItem)
          }
        }
        setFileDeleteSuccess(null)
      })
    } else if (fileDeleteSuccess === false) {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileDeleteSuccess])

  const { mutate: AddPrivateNote, isLoading: isAddPrivateNoteLoading } = useAddPrivateNoteMutation()

  const { mutate: UpdatePrivateNote, isLoading: isUpdatePrivateNoteLoading } =
    useUpdatePrivateNoteMutation()
  const { mutate: DeletePrivateNote, isLoading: isPrivateNoteDeleteLoading } =
    useDeletePrivateNoteMutation()
  const { mutate: DeleteUserTask, isLoading: isUserTaskDeleteLoading } = useDeleteUserTaskMutation()
  const { mutate: cancelUserCalendarEvent, isLoading: isCancelUserCalendarEventLoading } =
    useCancelUserCalendarEventMutation()
  const { mutate: updateUserCalendarEvent, isLoading: isUpdateUserCalendarEventLoading } =
    useUpdateUserCalendarEventMutation()
  const { mutate: updateTranscriptSummary, isLoading: isUpdateTranscriptSummary } =
    useUpdateTranscriptSummaryMutation()

  const { isLoading: isRequestMeetingLoading } = useRequestMeetingMutation()
  const { mutate: rescheduleUserCalendarEvent, isLoading: isRescheduleMeetingLoading } =
    useRescheduleUserCalendarEventMutation()
  const { refetchUserTasks } = useGetAdvisorAssignedTasks({
    filter: BusinessGoalDateFilter.EntireGamePlan,
    quickFilter: UserTaskQuickFilter.AllTasks,
    assigneeId: userId,
  })

  const toggleUpcomingDropdown = React.useCallback((meetingId) => {
    setOpenUpcomingDropdownIds((prevIds) => ({
      ...prevIds,
      [meetingId]: !prevIds[meetingId],
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getTackleMeetingEventsAction({ filter: filter, ownerId: userId })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, userId])

  const reloadMeetings = () => {
    getTackleMeetingEventsAction({ filter: 'previous', ownerId: userId })
  }

  const handleMeetingDelete = useCallback(
    (EventId, EventType, TackleId) => {
      try {
        cancelUserCalendarEvent(
          {
            input: {
              tenantId,
              eventId: EventId,
              eventType: EventType,
              tackleId: TackleId,
            },
          },
          {
            onSuccess: (e) => {
              setCancelMeetingModal(false)
              setConfirmMeetingModal(true)
              setShowModal(false)
              if (onMeetingActionSuccess) onMeetingActionSuccess()
            },
          }
        )
      } catch (error) {
        console.error('Error in handleFormSubmit:', error)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cancelUserCalendarEvent]
  )

  const handleDeleteSubmit = useCallback(
    (data, id) => {
      try {
        if (!data || !id) {
          throw new Error('Invalid data or id')
        }
        DeletePrivateNote(
          {
            calendarId: id.toString(),
            noteId: data,
          },
          {
            onSuccess: (e) => {
              reloadMeetings()
            },
          }
        )
      } catch (error) {
        console.error('Error in handleFormSubmit:', error)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [DeletePrivateNote]
  )

  const DeleteActionItem = useCallback(
    (data, id) => {
      try {
        DeleteUserTask(
          {
            input: {
              userId: clientID ?? userId,
              taskId: data,
              tenantId,
            },
          },
          {
            onSuccess: (e) => {
              refetchMeetingTask()
            },
          }
        )
      } catch (error) {
        console.error('Error in handleFormSubmit:', error)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [DeleteUserTask]
  )

  const handleFormSubmit = useCallback(
    (data, id, ownerId, advisorId, file, tag) => {
      try {
        if (!data || !id) {
          throw new Error('Invalid data or id')
        }
        AddPrivateNote(
          {
            calendarId: id.toString(),
            note: {
              content: data,
              createdBy: isBusinessOwner ? ownerId : advisorId,
              createdAt: moment().toDate().toISOString(),
              files: file,
              tags: tag,
              advisorId: !isBusinessOwner ? advisorId : '',
              clientId: clientId,
            },
          },
          {
            onSuccess: (e) => {
              setPrivateNoteFiles([])
              setPrivateNote('')
              reloadMeetings()
              setTaggedId([])
              setOpenNote(false)
            },
          }
        )
      } catch (error) {
        console.error('Error in handleFormSubmit:', error)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [AddPrivateNote]
  )

  const handleSummarySubmit = useCallback(
    (datas, id, file) => {
      try {
        updateTranscriptSummary(
          {
            calendarId: id.toString(),
            summaryDetails: {
              files: file,
              summaryDetails: datas,
            },
          },
          {
            onSuccess: (e) => {
              setPanelOpen(false)
              setPlaysFiles([])
              reloadMeetings()
            },
          }
        )
      } catch (error) {
        console.error('Error in handleFormSubmit:', error)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateTranscriptSummary]
  )

  const handleUpdateSubmit = useCallback(
    (data, id, UserId, ownerId, advisorId, file, tag) => {
      UpdatePrivateNote(
        {
          calendarId: UserId.toString(),
          note: {
            content: data,
            createdBy: isBusinessOwner ? ownerId : advisorId,
            createdAt: moment().toDate().toISOString(),
            noteId: id,
            files: file,
            tags: tag,
            advisorId: !isBusinessOwner ? advisorId : '',
            clientId: clientId,
          },
        },
        {
          onSuccess: (e) => {
            setPrivateNoteFiles([])
            reloadMeetings()
            setTaggedId([])
            setShowTextareaIndex(null)
          },
          onError: (error) => {
            // Error handling
          },
        }
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [UpdatePrivateNote]
  )

  const filteredMeetings = useMemo(() => {
    if (!searchResults) return meeting

    const lower = searchResults.toLowerCase()

    return meeting.filter(
      (m) =>
        (m.title && m.title.toLowerCase().includes(lower)) ||
        (m.organizerDetail?.firstName &&
          m.organizerDetail.firstName.toLowerCase().includes(lower)) ||
        (m.organizerDetail?.lastName && m.organizerDetail.lastName.toLowerCase().includes(lower)) ||
        (m.participantDetail?.firstName &&
          m.participantDetail.firstName.toLowerCase().includes(lower)) ||
        (m.participantDetail?.lastName &&
          m.participantDetail.lastName.toLowerCase().includes(lower))
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting, searchResults])

  const upcomingMeetingList = useMemo(() => {
    if (filter.includes('upcoming')) {
      const now = moment.tz(user?.timezone)

      return filteredMeetings
        ?.filter(
          (meet) =>
            meet.status !== 'cancelled' && moment.tz(meet.start, user?.timezone).isSameOrAfter(now)
        )
        .sort(
          (a, b) =>
            moment.tz(a.start, user?.timezone).valueOf() -
            moment.tz(b.start, user?.timezone).valueOf()
        )
    }
    return []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredMeetings, filter, user?.timezone])

  const previousMeetingList = useMemo(() => {
    if (filter.includes('previous')) {
      const now = moment.tz(user?.timezone)
      return filteredMeetings
        ?.filter((meet) => moment.tz(meet.start, user?.timezone).isSameOrBefore(now))
        .sort(
          (a, b) =>
            moment.tz(b.start, user?.timezone).valueOf() -
            moment.tz(a.start, user?.timezone).valueOf()
        )
    }
    return []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredMeetings, filter, user?.timezone])

  const canceledMeetingList = useMemo(() => {
    if (filter.includes('cancelled')) {
      return filteredMeetings
        ?.filter((meet) => meet.status === 'cancelled')
        .sort((a, b) => new Date(b.start).getTime() - new Date(a.start).getTime())
    }
    return []
  }, [filteredMeetings, filter])

  const getTimeDurationOfMetting = (timeRange?: string): string => {
    if (!timeRange || typeof timeRange !== 'string') return '00 hh 00 mm'
    const parts = timeRange.split(' - ')
    if (!parts || parts.length !== 2) return '00 hh 00 mm'
    const [startTime, endTime] = parts

    const parseTime = (t?: string): number => {
      if (!t || typeof t !== 'string') return 0
      const [time, modifier] = (t || '').trim().split(' ')
      if (!time) return 0
      const hm = time.split(':')
      let hours = Number(hm[0] ?? 0)
      let minutes = Number(hm[1] ?? 0)
      if (modifier === 'PM' && hours !== 12) hours += 12
      if (modifier === 'AM' && hours === 12) hours = 0
      return hours * 60 + minutes
    }

    const startMinutes = parseTime(startTime)
    const endMinutes = parseTime(endTime)
    const durationMinutes = Math.max(0, endMinutes - startMinutes)

    const hours = String(Math.floor(durationMinutes / 60)).padStart(2, '0')
    const minutes = String(durationMinutes % 60).padStart(2, '0')
    return `${hours} hh ${minutes} mm`
  }

  function toTitleCase(input) {
    return input?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
  }

  function getInitialsWithDots({
    firstName,
    lastName,
    email,
  }: {
    firstName?: string
    lastName?: string
    email?: string
  }): string {
    const firstInitial = firstName?.trim()?.[0]?.toUpperCase() || ''
    const lastInitial = lastName?.trim()?.[0]?.toUpperCase() || ''

    // Use name-based initials if available
    if (firstInitial || lastInitial) {
      return `${firstInitial}.${lastInitial}`
    }

    // Fallback to first letter of email username
    if (email) {
      const username = email.split('@')[0]?.trim()
      return username?.[0]?.toUpperCase() || ''
    }

    return ''
  }

  const onMeetingDelete = (eventId: string, eventType: string, id: string) => {
    setDeleteMeetinghPayload({ eventId, eventType, id })
    setCancelMeetingModal(true)
  }

  const confirmMeetingDelete = () => {
    if (meetingPayload) {
      handleMeetingDelete(meetingPayload?.eventId, meetingPayload?.eventType, meetingPayload?.id)

      setCancelMeetingModal(true)
      setDeleteMeetinghPayload(null)
    }
  }

  const handleCancelMeeting = () => {
    setCancelMeetingModal(false)
    setDeleteMeetinghPayload(null)
  }

  const onDeleteClick = (data: string, id: string) => {
    setDeletePayload({ data, id })
    setShowDeleteConfirm(true)
  }
  const handleConfirmDelete = () => {
    if (deletePayload) {
      handleDeleteSubmit(deletePayload.data, deletePayload.id)
      setShowDeleteConfirm(false) // Close dialog after action
      setDeletePayload(null) // Clean up
    }
  }

  const handleCancel = () => {
    setShowDeleteConfirm(false)
    setDeletePayload(null)
  }

  const onDeleteActionItem = (data: string | null | undefined, id: string) => {
    setDeleteActionPayload({ data, id })
    setShowDeleteActionItemConfirm(true)
  }
  const handleConfirmActionItemDelete = () => {
    if (deleteActionPayload) {
      DeleteActionItem(deleteActionPayload.data, deleteActionPayload.id)
      setShowDeleteActionItemConfirm(false) // Close dialog after action
      setDeleteActionPayload(null) // Clean up
    }
  }

  const handleActionItemCancel = () => {
    setShowDeleteActionItemConfirm(false)
    setDeleteActionPayload(null)
  }
  const handleClose = () => {
    handleActionItemCancel()
  }

  type ParsedMessage = {
    speaker: string
    message: string
  }

  let parsedMessages: ParsedMessage[] = []

  try {
    const rawTranscript = previousMettingById?.transcriptUrl

    const transcriptUrl = rawTranscript ? JSON.parse(rawTranscript) : null

    if (Array.isArray(transcriptUrl)) {
      parsedMessages = transcriptUrl.map((entry: any) => ({
        speaker: entry.speaker,
        message: entry.words.map((word: any) => word.text).join(' '), // Combine all words
      }))
    }
  } catch (error: any) {
    console.error('Invalid transcript JSON:', error.message)
  }

  const formatTimestamp = (seconds) => {
    const date = new Date(0)
    date.setSeconds(seconds)
    return date.toISOString().substr(11, 8) // "HH:MM:SS"
  }

  const getBlockLabel = (timestampInSec) => {
    const block = Math.floor(timestampInSec / 120) * 120
    return formatTimestamp(block)
  }

  function formatToCustom(dateString) {
    // Parse the ISO date string
    const date = new Date(dateString)

    // Create a new date in GMT-6
    const utcMillis = date.getTime()
    const offsetMillis = -6 * 60 * 60 * 1000 // GMT-6
    const localDate = new Date(utcMillis + offsetMillis)

    // Format date components
    const year = localDate.getUTCFullYear()
    const month = String(localDate.getUTCMonth() + 1).padStart(2, '0') // Months are 0-indexed
    const day = String(localDate.getUTCDate()).padStart(2, '0')
    const hours = String(localDate.getUTCHours()).padStart(2, '0')
    const minutes = String(localDate.getUTCMinutes()).padStart(2, '0')

    return `${year}-${month}-${day} ${hours}:${minutes} GMT-6`
  }

  const createDoc = async () => {
    const transcriptData = JSON.parse(previousMettingById?.transcriptUrl)

    const speakersSet = new Set()
    transcriptData.forEach((entry) => {
      if (entry.speaker) speakersSet.add(entry.speaker)
    })
    const attendees = Array.from(speakersSet).join(', ')
    // Group transcript entries by 2-minute blocks
    const grouped = {}
    transcriptData.forEach((entry) => {
      const start = entry.words?.[0]?.start_timestamp ?? 0
      const block = getBlockLabel(start)
      if (!grouped[block]) grouped[block] = []
      grouped[block].push(entry)
    })

    const docChildren: Paragraph[] = []

    // Header
    docChildren.push(
      new Paragraph({
        children: [new TextRun({ text: `${downloadDoc?.text}`, bold: true, size: 28 })],
        spacing: { after: 300 },
      }),
      new Paragraph({
        children: [
          new TextRun({
            text: `(${formatToCustom(downloadDoc?.start)}) - Transcript`,
            bold: true,
            size: 28,
          }),
        ],
        spacing: { after: 300 },
      }),
      new Paragraph({
        children: [new TextRun({ text: 'Attendees', bold: true, size: 24 })],
      }),

      new Paragraph(`${attendees},Coach Logic Bot`),

      new Paragraph({
        children: [new TextRun({ text: '\nTranscript', bold: true, size: 24 })],
        spacing: { after: 300 },
      }),
      new Paragraph(
        'This editable transcript was computer generated by Coach Logic Bot and might contain errors. People can also change the text after it was created.\n'
      )
    )

    // Grouped transcript blocks
    Object.entries(grouped).forEach(([blockTime, entries]) => {
      docChildren.push(
        new Paragraph({
          children: [new TextRun({ text: `${blockTime}`, bold: true, size: 24 })],
          spacing: { before: 300, after: 200 },
        })
      )

      if (Array.isArray(entries)) {
        entries.forEach((entry) => {
          const text = entry.words.map((w) => w.text).join(' ')

          docChildren.push(
            new Paragraph({
              children: [
                new TextRun({ text: `${entry.speaker}: `, bold: true }),
                new TextRun({ text }),
              ],
              spacing: { after: 100 },
            })
          )
        })
      }
    })

    // Create and download
    const doc = new Document({ sections: [{ children: docChildren }] })
    const blob = await Packer.toBlob(doc)
    saveAs(blob, `${downloadDoc?.text}${moment(downloadDoc?.start).format('YYYY-MM-DD')}.docx`)
  }

  const handleSaveUploadedFiles = async (uploadedFiles: UserFile[] | null) => {
    if (!uploadedFiles) throw new Error('No files uploaded')

    setPrivateNoteFiles(uploadedFiles)
    setShowAttachment(false)
  }

  const handleUploadedFiles = async (uploadedFiles: UserFile[] | null) => {
    if (!uploadedFiles) throw new Error('No files uploaded')

    setPlaysFiles(uploadedFiles)
    setShowAttachmentPlay(false)
  }
  const [showAttachment, setShowAttachment] = useState(false)
  const [showAttachmentPlay, setShowAttachmentPlay] = useState(false)

  const users = useSelector((state: RootState) => state.user)

  const participant: UserBasicInfo = {
    firstName:
      users?.user.firstName?.trim().toLowerCase() ===
      (selectedMeeting?.organizerDetail?.firstName?.trim().toLowerCase() || '')
        ? selectedMeeting?.participantDetail?.firstName || ''
        : selectedMeeting?.organizerDetail?.firstName || '',
    lastName:
      users?.user.lastName?.trim().toLowerCase() ===
      (selectedMeeting?.organizerDetail?.lastName?.trim().toLowerCase() || '')
        ? selectedMeeting?.participantDetail?.lastName || ''
        : selectedMeeting?.organizerDetail?.lastName || '',
  }

  function handleConfirmationCloseModal() {
    getTackleMeetingEventsAction({ filter: 'upcoming', ownerId: userId })
    setConfirmMeetingModal(false)
  }

  const filteredContacts = parsedInviteData.current.filter((contact) =>
    contact.firstName.toLowerCase().includes(searchQuery.toLowerCase())
  )

  const [showSucess, setShowSuccess] = useState(false)

  const handleCheckboxChange = (userObj: InvitedUser) => {
    const alreadyInvited = (invitedEmails ?? []).some((e) => e.email === userObj.email)

    if (alreadyInvited) {
      setInvitedEmails((invitedEmails ?? []).filter((e) => e.email !== userObj.email))
      setAttendee((attendee ?? []).filter((e) => e !== userObj.email))
    } else {
      setInvitedEmails([...(invitedEmails ?? []), userObj])
      // Merge new email with all existing attendees, avoiding duplicates
      const allAttendees = [
        ...(Array.isArray(inviteMeetingId?.attendeesEmail) ? inviteMeetingId.attendeesEmail : []),
        ...(attendee ?? []),
        userObj.email,
      ]
      setAttendee(Array.from(new Set(allAttendees)))
    }
  }

  const handleRemoveEmail = (user) => {
    setInvitedEmails((invitedEmails ?? []).filter((e) => e.email !== user.email))

    // Remove from already-invited if present
    if (
      inviteMeetingId &&
      Array.isArray(inviteMeetingId.attendeesEmail) &&
      inviteMeetingId.attendeesEmail.includes(user.email)
    ) {
      // Remove from inviteMeetingId.attendeesEmail
      const updatedAttendeesEmail = inviteMeetingId.attendeesEmail.filter((e) => e !== user.email)
      setInviteMeetingId({
        ...inviteMeetingId,
        attendeesEmail: updatedAttendeesEmail,
      })

      // Combine updatedAttendeesEmail and attendee (new invites), remove duplicates
      const combinedAttendees = Array.from(
        new Set([...updatedAttendeesEmail, ...attendee].filter((e) => e !== user.email))
      )

      setAttendee(combinedAttendees)

      setTimeout(() => {
        updateUserCalendarEvent(
          {
            input: {
              tackleId: inviteMeetingId?.tackleId,
              attendees: combinedAttendees,
              comment: inviteMeetingId?.comment,
              description: inviteMeetingId?.description,
              eventType: inviteMeetingId?.eventType,
              location: inviteMeetingId?.location,
              eventId: inviteMeetingId?.eventId,
              title: inviteMeetingId?.title,
              videoLinkDescription: inviteMeetingId?.videoLinkDescription,
            },
          },
          {
            onSuccess: (e) => {
              getTackleMeetingEventsAction({ filter: 'upcoming', ownerId: userId })
            },
          }
        )
      }, 0)
    }
  }

  const handleInvite = () => {
    const email = emailInput.trim()
    // Combine all emails that should not be duplicated
    const alreadyInvitedEmails = [
      ...(invitedEmails ?? []).map((invited) => invited.email),
      ...(Array.isArray(inviteMeetingId?.attendeesEmail) ? inviteMeetingId.attendeesEmail : []),
    ]

    if (email && !alreadyInvitedEmails.includes(email)) {
      const emailObj = {
        email,
        firstName: email,
        lastName: '',
      }
      setInvitedEmails([...(invitedEmails ?? []), emailObj])

      // Merge new email with all existing attendees, avoiding duplicates
      const allAttendees = [
        ...(Array.isArray(inviteMeetingId?.attendeesEmail) ? inviteMeetingId.attendeesEmail : []),
        ...(attendee ?? []),
        emailObj.email,
      ]
      setAttendee(Array.from(new Set(allAttendees)))
      setEmailInput('')
    }
  }

  const InviteUsersMutate = () => {
    updateUserCalendarEvent(
      {
        input: {
          tackleId: inviteMeetingId?.tackleId,
          attendees: attendee,
          comment: inviteMeetingId?.comment,
          description: inviteMeetingId?.description,
          eventType: inviteMeetingId?.eventType,
          location: inviteMeetingId?.location,
          eventId: inviteMeetingId?.eventId,
          title: inviteMeetingId?.title,
          videoLinkDescription: inviteMeetingId?.videoLinkDescription,
        },
      },
      {
        onSuccess: (e) => {
          setInviteMeetingId(null)
          setShowSuccess(true)
          getTackleMeetingEventsAction({ filter: 'upcoming', ownerId: userId })
        },
      }
    )
  }

  const colorClasses = [
    { bg: 'bg-orange-light', text: 'text-orange' },
    { bg: 'bg-green-lighter2x', text: 'text-green-dark' },
    { bg: 'bg-purple-lighter3x', text: 'text-purple-light' },
    { bg: 'bg-red-light', text: 'text-red' },
    { bg: 'bg-yellow-light', text: 'text-yellow-darkest' },
    { bg: 'bg-brown-light', text: 'text-brown-dark' },
    { bg: 'bg-sky', text: 'text-blue-dark' },
    { bg: 'bg-brown-light', text: 'text-brown-dark' },
    { bg: 'bg-blue-lightest', text: 'text-blue-dark' },
  ]

  const getColorIndex = ({ email, firstName, lastName }) => {
    // Case 1: Use email if available
    if (email && typeof email === 'string' && email.length > 0) {
      let hash = 0
      for (let i = 0; i < email.length; i++) {
        hash = email.charCodeAt(i) + ((hash << 5) - hash)
      }
      return Math.abs(hash) % colorClasses.length
    }

    // Case 2: Use firstName + lastName if either is available
    const fullName = [firstName, lastName].filter(Boolean).join('') // handles missing lastName
    if (fullName.length > 0) {
      let hash = 0
      for (let i = 0; i < fullName.length; i++) {
        hash = fullName.charCodeAt(i) + ((hash << 5) - hash)
      }
      return Math.abs(hash) % colorClasses.length
    }

    // Case 3: Fallback to random
    return Math.floor(Math.random() * colorClasses.length)
  }
  const currentDate = new Date()
  const startTime = currentDate.toISOString()
  const endTime = addDays(currentDate, 26).toISOString()
  const [availableSlots, setAvailableSlots]: any = useState([])
  const [selectedClient, setSelectedClient] = useState<any>(null)

  const [selectedAdvisor, setSelectedAdvisor] = useState<any>(null)
  const [selectedDuration, setSelectedDuration] = useState<string | number | null>(null)
  const availabilityErrorMessage = `The business owner's calendar is having connection errors. Please message them to reschedule a meeting.`
  const [calendarDate, setCalendarDate] = useState(new Date())
  const [startDateTime, setStartDateTime] = useState(new Date())
  const [meetingDescription, setMeetingDescription] = useState(EditorState.createEmpty())

  useEffect(() => {
    removeFlashParams(['availabilityConnectionError'])
    setSelectedDuration(0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSelect = (value) => {
    setSelectedClient(value)
  }

  const handleSelectAdvisor = (value) => {
    setSelectedAdvisor(value)
  }
  useEffect(() => {
    dispatch(getBoAdvisorAction.STARTED({}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getBoAdvisorAction])

  const list = useSelector((state: RootState) => state.clients?.list)
  useEffect(() => {
    if (!list?.length) {
      dispatch(getAdvisorDashboardAction.STARTED({}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAdvisorDashboardAction, list?.length])

  const {
    userAvailabilityStatus,
    meetingStepper,
    boAdvisors,
    advisorProfile,

    userAvailabilityHoursList,
    errorMessage,
  } = useSelector((state: RootState) => state.calendar)
  const { isAvailabilityHoursLoading } = useSelector((state: RootState) => state.loadingStatus)

  const selectedAdvisorId = useMemo(() => {
    return boAdvisors.find((advisor) => advisor.id === selectedAdvisor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boAdvisors, selectedAdvisor])

  const handleChangeAvailability = (duration: string) => {
    if (toNumber(duration) !== selectedDuration) {
      setSelectedDuration(toNumber(duration))

      dispatch(
        getUserAvailabilityAction.STARTED({
          role: [getUserRole()],
          startTime,
          endTime,
          participantId: selectedClient?.value?.id,
          timeZone: user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
          duration: toNumber(duration),
        })
      )
    }
  }
  const handleChangeAvailabilityAdvisor = (duration: string) => {
    if (toNumber(duration) !== selectedDuration) {
      setSelectedDuration(toNumber(duration))
      dispatch(
        getUserAvailabilityAction.STARTED({
          role: [getUserRole()],
          startTime,
          endTime,
          participantId: selectedAdvisor?.value?.id,
          timeZone: user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
          duration: toNumber(duration),
        })
      )
    }
  }

  const methods = useForm({
    mode: 'all',
    resolver: yupResolver(meetingsSchema),
  })

  const { control } = methods
  const form = hookForms.getForm(FORM.MEETING_SCHEDULED)
  const formData = form?.getValues()
  const isBusinessOwner =
    getRoleFromPath() === ROLES.BUSINESS_OWNER || getRoleFromPath() === ROLES.V2
  const participantName = isBusinessOwner ? selectedAdvisor : selectedClient
  const participantLabel = isBusinessOwner ? 'Advisor' : 'Client'
  const userRoles = useMemo(
    () => user.roles,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user]
  )
  const userRole = getRoleFromPath()
  let timeZone = user?.timezone ?? moment.tz.guess()

  const currentTime = timeZone
    ? moment(new Date()).tz(timeZone).format('hh:mm a')
    : moment().format('hh:mm a')
  const [selectedDate, setSelectedDate] = useState('')
  const [selectedSlot, setSelectedSlot] = useState({
    slotStartTime: null,
    slotEndTime: null,
    slotStartDate: null,
    slotEndDate: null,
  })

  const handleChangeConflicts = (event) => {
    dispatch(
      getUserAvailabilityAction.STARTED({
        role: [getUserRole()],
        startTime: startDateTime.toISOString(),
        endTime: addDays(startDateTime, 31).toISOString(),
        participantId: userRoles?.includes(USER_ROLES.BUSINESS_OWNER)
          ? selectedAdvisor?.value?.id
          : selectedClient && selectedClient?.value?.id,
        timeZone: user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
        duration: toNumber(selectedDuration),
        ignoreConflicts: event.target.checked,
      })
    )
  }
  const handleCalendarChange = (date) => {
    setCalendarDate(date)
    setSelectedDate(moment(date).local().format('YYYY-MM-DD'))
  }

  useEffect(() => {
    removeFlashParams(['availabilityConnectionError'])
    setSelectedDuration(0)
    if (selectedAdvisorId) {
      dispatch(getUserAvailabilityHoursAction.STARTED({ selectedAdvisorId }))
      dispatch(getAdvisorProfileAction.STARTED({ advisorId: selectedAdvisorId }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getUserAvailabilityAction, selectedAdvisorId, userRole, getAdvisorProfileAction])

  useEffect(() => {
    if (selectedDate && userAvailabilityList?.availability) {
      const availability = userAvailabilityList.availability.find(
        (slot) => slot?.date === selectedDate
      )

      setAvailableSlots(availability?.slots || [])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, userAvailabilityList])

  const bsoProfile = useSelector((state: RootState) => state.bso.bsoProfile)
  let advisorTerm = replaceTerm('advisor', bsoProfile.terminology)?.toLocaleLowerCase()
  advisorTerm = advisorTerm.charAt(0).toUpperCase() + advisorTerm.slice(1)
  const isError =
    selectedAdvisor &&
    userAvailabilityStatus === availabilityStatus.FAILED &&
    selectedDuration != null &&
    !isEmpty(selectedDuration.toString())

  const availabilityErrorMessageAdvisor = flashParams.availabilityConnectionError
    ? `Your ${advisorTerm}’s calendar is having connection errors.
Please message them to schedule a meeting.`
    : `Your ${advisorTerm}'s availability has not been set. Please message them to schedule a
meeting.`
  const availabilityDurations = userAvailabilityHoursList?.duration
    ? sortBy(userAvailabilityHoursList.duration, (num) => parseInt(num))
    : []
  const durationOptions = !isEmpty(availabilityDurations)
    ? availabilityDurations.map((duration) => ({
        label: `${duration} min.`,
        value: duration,
      }))
    : timeDurationAvailabilityOptions

  let dateObj = moment(selectedDate, 'YYYY-MM-DD')
  let formattedDate = dateObj.format('dddd, MMMM D, YYYY')

  function getTileClassName({ date, view, userAvailabilityList }) {
    if (view === 'month' && userAvailabilityList) {
      if (checkAvailability(date, userAvailabilityList)) {
        return 'highlight'
      }
    }

    return ''
  }

  const handleTileClick = (date) => {
    dispatch(
      updateMeetingStepperAction({ actionType: 'increment', stepName: MEETING_STEPPER.SLOTS })
    )
    setSelectedDate(moment(date).local().format('YYYY-MM-DD'))
  }

  const refreshAdvisorAvailability = ({ action, activeStartDate, value, view }) => {
    if (action !== ACTION_TYPE.OnChange) {
      const currentUserRole = getUserRole()
      const duration =
        currentUserRole === USER_ROLES.BUSINESS_OWNER
          ? userAvailabilityList.duration
          : selectedDuration
      const startTime = activeStartDate.toISOString()
      const endTime = addDays(activeStartDate, 31).toISOString()
      dispatch(
        getUserAvailabilityAction.STARTED({
          role: [currentUserRole],
          startTime,
          endTime,
          participantId: participantName?.value?.id,
          timeZone: user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
          duration,
          ignoreConflicts: formData?.ignoreConflicts ?? false,
        })
      )
    }
    setCalendarDate(activeStartDate)
    setStartDateTime(activeStartDate)
  }

  const refreshRequestAvailability = ({ action, activeStartDate, value, view }) => {
    if (action !== ACTION_TYPE.OnChange) {
      const currentUserRole = getUserRole()
      const duration =
        currentUserRole === USER_ROLES.BUSINESS_OWNER
          ? userAvailabilityList.duration
          : selectedDuration
      const startTime = activeStartDate.toISOString()
      const endTime = addDays(activeStartDate, 31).toISOString()
      dispatch(
        getUserAvailabilityAction.STARTED({
          role: [currentUserRole],
          startTime,
          endTime,
          participantId: isBusinessOwner ? requestId?.advisorId : requestId?.ownerId,
          timeZone: user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
          duration,
          ignoreConflicts: formData?.ignoreConflicts ?? false,
        })
      )
    }
    setCalendarDate(activeStartDate)
    setStartDateTime(activeStartDate)
  }

  const onSubmit = () => {
    const meetingForm = methods.getValues()
    methods.reset()
    let description =
      convertToRaw(meetingDescription.getCurrentContent()).blocks[0].text.length > 0
        ? draftToHtml(convertToRaw(meetingDescription.getCurrentContent()))
        : ''
    const extraAttendeesEmails = meetingForm?.attendees
      ? meetingForm.attendees.split(',').map((attendee) => attendee.trim())
      : []

    // Merge with rescheduleAppointId.attendees if available and is an array

    rescheduleUserCalendarEvent(
      {
        input: {
          tackleId: tenantId,
          startTime: selectedSlot?.slotStartDate ?? '',
          endTime: selectedSlot?.slotEndDate ?? '',
          attendees: extraAttendeesEmails,
          comment: rescheduleAppointId?.comment,
          description: description,
          eventId: rescheduleAppointId?.id,
          eventType: rescheduleAppointId?.eventType,
          location: meetingForm?.meetingLocation,
          title: meetingForm?.meetingTitle,
          videoLinkDescription: meetingForm?.videoLinkDescription,
        },
      },
      {
        onSuccess: (e) => {
          setRescheduleAppointId([])
          dispatch(
            updateMeetingStepperAction({
              actionType: 'reset',
              stepName: MEETING_STEPPER.ADVISOR,
            })
          )
          badge('upcoming')
          setSelectedDuration(null)
          setAvailableSlots(null)
          setSelectedAdvisor(null)
          setSelectedClient(null)
          setSelectedDuration(null)
          setMeetingDescription(EditorState.createEmpty())

          getTackleMeetingEventsAction({ filter: 'upcoming', ownerId: userId })
          if (onMeetingActionSuccess) onMeetingActionSuccess()
        },
      }
    )
  }

  const onSubmitRescheduleCancel = () => {
    const meetingForm = methods.getValues()
    methods.reset()
    let description =
      convertToRaw(meetingDescription.getCurrentContent()).blocks[0].text.length > 0
        ? draftToHtml(convertToRaw(meetingDescription.getCurrentContent()))
        : ''
    const extraAttendeesEmails = meetingForm?.attendees
      ? meetingForm.attendees.split(',').map((attendee) => attendee.trim())
      : []

    rescheduleUserCalendarEvent(
      {
        input: {
          tackleId: tenantId,
          startTime: selectedSlot?.slotStartDate ?? '',
          endTime: selectedSlot?.slotEndDate ?? '',
          attendees: extraAttendeesEmails,
          comment: rescheduleAppointId?.comment,
          description,
          eventId: rescheduleAppointId?.id,
          eventType: rescheduleAppointId?.eventType,
          location: meetingForm?.meetingLocation,
          title: meetingForm?.meetingTitle,
          videoLinkDescription: meetingForm?.videoLinkDescription,
        },
      },
      {
        onSuccess: (e) => {
          setRescheduleAppointId([])
          dispatch(
            updateMeetingStepperAction({
              actionType: 'reset',
              stepName: MEETING_STEPPER.ADVISOR,
            })
          )
          setAvailableSlots(null)
          setSelectedAdvisor(null)
          setSelectedClient(null)
          setSelectedDuration(null)
          setMeetingDescription(EditorState.createEmpty())

          badge('previous')
          getTackleMeetingEventsAction({ filter: 'cancelled', ownerId: userId })
          if (onMeetingActionSuccess) onMeetingActionSuccess()
        },
      }
    )
  }

  const error = errorMessage
    ? `We were unable to create the meeting with ${selectedAdvisor?.firstName}
${selectedAdvisor?.lastName}. It’s probably us, not you!`
    : ''

  const successMessage = !error
    ? `${selectedAdvisor?.firstName} ${selectedAdvisor?.lastName} has received a new meeting notification that includes all of the meeting details.`
    : ''

  const start = requestId?.start ? new Date(requestId.start) : null
  const end = requestId?.end ? new Date(requestId?.end) : null

  const isValidDate = (date: any) => date instanceof Date && !isNaN(date.getTime())

  const durationMs =
    isValidDate(start) && isValidDate(end) && start && end ? end.getTime() - start.getTime() : 0 // Difference in milliseconds

  const durationMinutes = durationMs > 0 ? durationMs / (1000 * 60) : 0

  useEffect(() => {
    if (!rescheduleAppointId || !rescheduleAppointId.organizerDetail) return

    const { organizerDetail, participantDetail, start, end } = rescheduleAppointId

    const isValidDate = (date: any) => date instanceof Date && !isNaN(date.getTime())

    const startTime = start ? new Date(start) : null
    const endTime = end ? new Date(end) : null

    const durationMs =
      isValidDate(startTime) && isValidDate(endTime) ? endTime!.getTime() - startTime!.getTime() : 0
    const durationMinute = durationMs > 0 ? durationMs / (1000 * 60) : 0

    const normalizeUsers = (users: any[]) =>
      users
        .map((user) => {
          const fullName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()
          return {
            ...user,
            fullName,
          }
        })
        .sort((a, b) => a.fullName.localeCompare(b.fullName))
        .map((user) => ({
          label: `${user.fullName}${user.businessName ? ` (${user.businessName})` : ''}`,
          value: user,
        }))

    const advisorOptions = Array.isArray(boAdvisors) ? normalizeUsers(boAdvisors) : []
    const clientOptions = Array.isArray(list)
      ? normalizeUsers(list.filter(({ status }) => status === 'active'))
      : []

    // Step 1: Match organizerDetail with boAdvisors
    const matchedAdvisor = advisorOptions.find(
      ({ value }) =>
        value.id === rescheduleAppointId.inviteeId || value.email === organizerDetail?.email
    )

    // Step 2: If not matched, and business owner, try participantDetail with boAdvisors
    let advisorFallbackMatch: typeof advisorOptions[number] | null = null
    if (!matchedAdvisor && isBusinessOwner && participantDetail) {
      advisorFallbackMatch =
        advisorOptions.find(
          ({ value }) =>
            value.email === participantDetail.email ||
            value.firstName === participantDetail.firstName
        ) || null
    }

    // Step 3: If no advisor match at all, try organizerDetail with client list
    let matchedClient =
      !matchedAdvisor && !advisorFallbackMatch
        ? clientOptions.find(
            ({ value }) =>
              value.email === organizerDetail?.email ||
              value.firstName === organizerDetail?.firstName
          )
        : null

    // Step 4: If still no match, and NOT business owner, try participantDetail with client list
    let clientFallbackMatch: typeof clientOptions[number] | null = null
    if (
      !matchedAdvisor &&
      !advisorFallbackMatch &&
      !matchedClient &&
      !isBusinessOwner &&
      participantDetail
    ) {
      clientFallbackMatch =
        clientOptions.find(
          ({ value }) =>
            value.email === participantDetail.email ||
            value.firstName === participantDetail.firstName
        ) || null
    }

    const match = matchedAdvisor || advisorFallbackMatch || matchedClient || clientFallbackMatch

    if (match && isValidDate(startTime) && isValidDate(endTime) && endTime) {
      const endTimePlus31Days = new Date(endTime.getTime() + 31 * 24 * 60 * 60 * 1000)
      dispatch(
        getUserAvailabilityAction.STARTED({
          role: [getUserRole()],
          startTime,
          endTime: endTimePlus31Days,
          participantId: match.value.id,
          timeZone: user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
          duration: toNumber(durationMinute),
        })
      )

      if (matchedAdvisor || advisorFallbackMatch) {
        setSelectedAdvisor(match)
      } else if (matchedClient || clientFallbackMatch) {
        setSelectedClient(match)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rescheduleAppointId, boAdvisors, list])

  useEffect(() => {
    if (meetingStepper === MEETING_STEPPER.CLOSE_MODAL) {
      setRescheduleAppointId([])
      dispatch(
        updateMeetingStepperAction({
          actionType: 'reset',
          stepName: MEETING_STEPPER.ADVISOR,
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetingStepper])

  useEffect(() => {
    if (isUpdateTaskSuccess) {
      refetchMeetingTask()
      setIsUpdateTaskSuccess(false) // reset the flag if you want to allow future triggers
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateTaskSuccess, refetchMeetingTask])

  // Function to parse and render text with mentions
  const renderNoteWithMentions = (text: string, allUsers: MentionUser[] = []) => {
    if (!text) return null

    return text.split(/(@\w+)/g).map((part, idx) => {
      if (part.startsWith('@')) {
        const username = part.slice(1).toLowerCase()
        const user = allUsers.find((u) => `${u.firstName}${u.lastName}`.toLowerCase() === username)

        return (
          <span
            key={idx}
            className="bg-[#EAE9FE] text-[#5C37EB] px-2 py-0.5 rounded-md text-sm font-medium mx-0.5"
          >
            {user ? `@${user.firstName} ${user.lastName}` : part}
          </span>
        )
      }
      return <span key={idx}>{part}</span>
    })
  }

  const getUserNameById = (id) => {
    const user = allUsers.find((u) => u.id === id)
    if (!user) return 'Unknown User'
    return `${user.firstName} ${user.lastName}`
  }

  return (
    <div className=" w-full">
      {showDeleteActionItemConfirm && (
        <ModalBox
          height={'xs:h-full sm:h-auto max-h-full'}
          Icon={MeetingCancelIcon}
          margin="sm:mx-5"
          onClose={handleClose}
        >
          <MeetingConfirmation
            labelText={`Yes, delete`}
            errorMessage=""
            successMessage=""
            isWarning={true}
            handleClose={handleConfirmActionItemDelete}
            handleCancel={handleActionItemCancel}
            isLoading={isUserTaskDeleteLoading}
            Heading="Are you sure you want to delete?"
          />
        </ModalBox>
      )}

      {showDeleteConfirm && (
        <ModalBox
          height={'xs:h-full sm:h-auto max-h-full'}
          Icon={MeetingCancelIcon}
          margin="sm:mx-5"
          onClose={handleCancel}
        >
          <MeetingConfirmation
            labelText={`Yes, delete`}
            errorMessage=""
            successMessage=""
            isWarning={true}
            handleClose={handleConfirmDelete}
            handleCancel={handleCancel}
            isLoading={isPrivateNoteDeleteLoading}
            Heading="Are you sure you want to delete?"
          />
        </ModalBox>
      )}

      {cancelMeetingModal && (
        <ModalBox
          height={'xs:h-full sm:h-auto max-h-full'}
          Icon={MeetingCancelIcon}
          margin="sm:mx-5"
          onClose={handleCancelMeeting}
        >
          <MeetingConfirmation
            labelText={`Yes, cancel`}
            errorMessage=""
            successMessage=""
            isWarning={true}
            handleClose={confirmMeetingDelete}
            handleCancel={handleCancelMeeting}
            isLoading={isCancelUserCalendarEventLoading}
            Heading={'Are you sure you want to cancel?'}
          />
        </ModalBox>
      )}
      {showTranscript && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-xl mx-auto p-6 rounded-[16px] shadow-lg">
            <div className="relative mb-4 text-center">
              <div className="w-96 text-center inline-block"></div>
              <h5 className="text-md font-medium pt-0 text-xl">Transcript</h5>
            </div>

            <div className="p-4 max-w-xl mx-auto max-h-[600px] overflow-auto">
              {parsedMessages.length > 0 ? (
                parsedMessages.map((msg, index) => (
                  <div key={index} className="mb-4 p-3  rounded shadow-sm bg-white">
                    <div className="text-sm font-semibold text-gray-700">{msg.speaker}: </div>
                    <div className="text-gray-800 mt-1">{msg.message}</div>
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-500">No transcript data available.</div>
              )}
            </div>

            <div className=" gap-2 flex-row">
              <button
                onClick={() => setShowTranscript(false)}
                className="px-4 py-2 bg-purple text-white rounded-lg w-1/2 border border-grey-lighter4x"
              >
                Close
              </button>
              <button
                onClick={() => createDoc()}
                className="px-4 py-2 bg-purple text-white rounded-lg w-1/2 border border-grey-lighter4x"
              >
                Download
              </button>
            </div>
          </div>
        </div>
      )}
      {showAttachment && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-md mx-auto p-6 rounded-[16px] shadow-lg">
            <div className="relative mb-4 text-center">
              <div className="w-96 text-center inline-block"></div>
              <h5 className="text-md font-medium pt-3 text-xl">Send Attachment</h5>
              <button
                onClick={() => {
                  setShowAttachment(false)
                  setPrivateNoteFiles([])
                }}
                className="text-gray-600 hover:text-gray-900 absolute right-2 top-2"
              >
                <i className="fas fa-times "></i>
              </button>
            </div>

            <AppFileUploader onUploadCompleted={handleSaveUploadedFiles} allowedFormats={[]} />
            <div className="flex flex-col gap-4">
              {privateNoteFiles.map((file) => (
                <AppTaskFileCard key={file.id} file={file} />
              ))}
            </div>
          </div>
        </div>
      )}
      {showAttachmentPlay && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-md mx-auto p-6 rounded-[16px] shadow-lg">
            <div className="relative mb-4 text-center">
              <div className="w-96 text-center inline-block"></div>
              <h5 className="text-md font-medium pt-3 text-xl">Send Attachment</h5>
              <button
                onClick={() => {
                  setShowAttachmentPlay(false)
                  setPlaysFiles([])
                }}
                className="text-gray-600 hover:text-gray-900 absolute right-2 top-2"
              >
                <i className="fas fa-times "></i>
              </button>
            </div>

            <AppFileUploader onUploadCompleted={handleUploadedFiles} allowedFormats={[]} />
            <div className="flex flex-col gap-4">
              {playsFiles.map((file) => (
                <AppTaskFileCard key={file.id} file={file} />
              ))}
            </div>
          </div>
        </div>
      )}
      {showDetails ? (
        <>
          <section className="pb-8 px-5 mb:px-0 mt-6">
            <div className="mx-auto">
              <div className="mb-8">
                <div
                  onClick={() => {
                    setShowDetails(false)
                    status('open')
                    reloadMeetings()
                    setPanelOpen(false)
                  }}
                  className="inline-block px-4 py-3 bg-white text-[#121212] rounded-lg cursor-pointer border border-[#DBDBDB]"
                >
                  Back to Meeting Record
                </div>
              </div>

              <div className="mb-6">
                <h4 className="flex items-center text-4xl font-medium">
                  {/* <img
                    className="h-8 w-8 mr-3"
                    src={require('../../../../appAssets/appImages/suitcase.png')}
                    alt=""
                  /> */}
                  Meeting Details
                </h4>
                <p
                  className="text-gray-600"
                  dangerouslySetInnerHTML={{ __html: previousMettingById?.description }}
                ></p>
              </div>

              <div className="bg-white shadow-lg rounded-lg border border-[#F5F5F5] p-6 mb-8">
                <h6 className="font-medium flex items-center gap-2 text-2xl border-b border-[#ECECEC] pb-2">
                  {previousMettingById?.title || 'NA'}
                </h6>
                <div className="pt-4">
                  <p className="text-md text-[#3F3F46]">
                    <strong className="w-full md:w-60 inline-block font-bold">Date & Time:</strong>
                    <span className="text-[#18181B]">
                      {(moment as any).tz
                        ? moment
                            .tz(previousMettingById?.start, user?.timeZone)
                            .format('MMMM D, YYYY')
                        : moment(previousMettingById?.start).format('MMMM D, YYYY')}{' '}
                      | {previousMettingById?.time}{' '}
                      {(moment as any).tz && previousMettingById?.timezone
                        ? moment().tz(previousMettingById?.timezone).format('z')
                        : ''}
                    </span>
                  </p>
                  <p className="pt-5 text-md text-[#3F3F46]">
                    <strong className="w-full md:w-60  inline-block font-bold">
                      Actual Meeting Duration:
                    </strong>
                    <span className="text-[#18181B]">
                      {getTimeDurationOfMetting(previousMettingById?.time)}
                    </span>
                  </p>
                  <p className="pt-4 flex flex-wrap md:flex-nowrap items-center text-md text-[#3F3F46]">
                    <strong className="w-full md:w-60  inline-block font-bold">
                      Participants:
                    </strong>
                    <div className="flex -space-x-1 ">
                      <span
                        className={` ${
                          colorClasses[
                            getColorIndex({
                              email: '',
                              firstName: previousMettingById?.organizerDetail?.firstName,
                              lastName: previousMettingById?.organizerDetail?.lastName,
                            })
                          ]?.bg
                        } ${
                          colorClasses[
                            getColorIndex({
                              email: '',
                              firstName: previousMettingById?.organizerDetail?.firstName,
                              lastName: previousMettingById?.organizerDetail?.lastName,
                            })
                          ]?.text
                        } flex border border-white w-8 h-8 text-center font-medium items-center justify-center  text-[16px] rounded-full `}
                      >
                        {getInitialsWithDots({
                          firstName: previousMettingById?.organizerDetail?.firstName,
                          lastName: previousMettingById?.organizerDetail?.lastName,
                          email: '',
                        })}
                      </span>

                      <span
                        className={` ${
                          colorClasses[
                            getColorIndex({
                              email: '',
                              firstName: previousMettingById?.participantDetail?.firstName,
                              lastName: previousMettingById?.participantDetail?.lastName,
                            })
                          ]?.bg
                        } ${
                          colorClasses[
                            getColorIndex({
                              email: '',
                              firstName: previousMettingById?.participantDetail?.firstName,
                              lastName: previousMettingById?.participantDetail?.lastName,
                            })
                          ]?.text
                        }  flex border border-white w-8 h-8 text-center font-medium items-center justify-center  text-[16px] rounded-full `}
                      >
                        {getInitialsWithDots({
                          firstName: previousMettingById?.participantDetail?.firstName,
                          lastName: previousMettingById?.participantDetail?.lastName,
                          email: '',
                        })}
                      </span>
                      {(previousMettingById?.attendeesEmail ?? []).map((email: string) => (
                        <>
                          <span
                            className={`${
                              colorClasses[
                                getColorIndex({
                                  email: email,
                                  firstName: '',
                                  lastName: '',
                                })
                              ]?.bg
                            } ${
                              colorClasses[
                                getColorIndex({
                                  email: email,
                                  firstName: '',
                                  lastName: '',
                                })
                              ]?.text
                            } flex border border-white w-8 h-8 text-center font-medium items-center justify-center text-[16px] rounded-full`}
                          >
                            {getInitialsWithDots({
                              firstName: '',
                              lastName: '',
                              email: email,
                            })}
                          </span>
                        </>
                      ))}
                    </div>
                    {(previousMettingById?.attendeesEmail?.length ?? 0) !== 0 ? (
                      <span className="flex -space-x-1 "></span>
                    ) : (
                      <></>
                    )}
                  </p>

                  <div className=" mt-4 md:-mt-10 flex space-x-4 justify-end ">
                    <Tooltip
                      id="transcript"
                      style={{
                        zIndex: 1000,
                        backgroundColor: '#705AF8',
                        color: '#ECECEC',
                        maxWidth: 320,
                        textAlign: 'left',
                      }}
                      opacity={100}
                      noArrow
                    />
                    <div
                      data-tooltip-id={parsedMessages.length > 0 ? '' : 'transcript'}
                      data-tooltip-content="Transcript is unavailable"
                      onClick={() => {
                        if (parsedMessages.length > 0) {
                          setShowTranscript(true)
                          setDownloadDoc(previousMettingById)
                        }
                      }}
                      className={
                        parsedMessages.length > 0
                          ? 'px-4 py-3 bg-purple text-white rounded-lg cursor-pointer  flex items-center'
                          : 'px-4 py-3 bg-[#B7B7B7] text-white rounded-lg   flex items-center'
                      }
                    >
                      <span className="text-white me-1 text-sm">View Transcript</span>
                      <img
                        src={require('../../../../appAssets/appImages/document-text.png')}
                        alt=""
                        className={parsedMessages.length > 0 ? 'w-6 cursor-pointer' : 'w-6'}
                      />
                    </div>

                    <div
                      data-tooltip-id={previousMettingById?.recordingUrl ? '' : 'transcript'}
                      data-tooltip-content="Recording is unavailable"
                      onClick={() => {
                        if (previousMettingById?.recordingUrl) {
                          window.open(`${previousMettingById?.recordingUrl}`, '_blank')
                        }
                      }}
                      className={
                        previousMettingById?.recordingUrl
                          ? 'px-4 py-3 bg-purple cursor-pointer rounded-lg text-white flex items-center'
                          : 'px-4 py-3 bg-[#B7B7B7] rounded-lg text-[#5E5E5E] flex items-center'
                      }
                    >
                      <span className="text-white me-1 text-md">Download Recording</span>
                      <img
                        src={require('../../../../appAssets/appImages/cloud-arrow-down.png')}
                        alt=""
                        className={previousMettingById?.recordingUrl ? 'w-6 cursor-pointer' : 'w-6'}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-8">
                <div className="flex items-start space-x-2 mb-2 justify-between">
                  <h6 className="text-md text-[#121212] font-medium w- flex items-center">
                    Summary
                    <span className="text-md font-normal">
                      {panelOpen ? (
                        <img
                          onClick={() => setPanelOpen(true)}
                          src={require('../../../../appAssets/appImages/information-circle.png')}
                          alt=""
                          className="w-5 h-5 inline-block ml-2"
                        />
                      ) : (
                        <span className="text-md text-gray-500 ml-1"> (AI generated)</span>
                      )}
                    </span>
                  </h6>
                  <div className="flex ">
                    {previousMettingById?.transcriptSummaryFile?.length > 0 && (
                      <div
                        style={{ display: !panelOpen ? 'flex' : 'none' }}
                        className="mt-1 cursor-pointer"
                        onClick={() => {
                          window.open(`${previousMettingById?.transcriptSummaryFile}`, '_blank')
                        }}
                      >
                        <AppFileIconDouble />
                      </div>
                    )}
                    <img
                      style={{ display: !panelOpen ? 'flex' : 'none' }}
                      onClick={() => {
                        setPanelOpen(true)
                        setData(previousMettingById?.transcriptSummary)
                      }}
                      src={require('../../../../appAssets/appImages/edit.png')}
                      alt=""
                      className="w-8 h-8 p-1 cursor-pointer"
                    />
                  </div>
                </div>
                {!panelOpen && (
                  <p className="text-md text-[#4F4F4F] font-normal">
                    {renderNoteWithMentions(previousMettingById?.transcriptSummary, allUsers) ||
                      'no summary available '}
                  </p>
                )}
              </div>
              {panelOpen && (
                <div className="relative mb-8 bg-gray-100 rounded-lg">
                  <div className="border border-[#ececec] rounded-lg px-4 py-4">
                    <textarea
                      value={data}
                      ref={summaryRef}
                      defaultValue={previousMettingById?.transcriptSummary}
                      onChange={handleChange}
                      placeholder="Write your comment"
                      className="w-full p-2 mb-4 focus:outline-0 min-h-[200px]"
                    ></textarea>

                    {showMentionList && (
                      <div
                        ref={mentionPickerRef}
                        className="absolute bg-white shadow-lg rounded-lg border border-[#ececec] mt-1 max-h-40 overflow-auto z-20 w-80"
                      >
                        {filteredUsers.length > 0 ? (
                          filteredUsers.map((user) => (
                            <div
                              key={user.id}
                              className="px-3 py-2 cursor-pointer hover:bg-gray-100 flex items-center gap-3 justify-between"
                              onClick={() => handleUserSelect(user)}
                            >
                              <div className="flex items-center gap-3 text-sm">
                                <div
                                  className={`${
                                    colorClasses[
                                      getColorIndex({
                                        email: '',
                                        firstName: user?.firstName,
                                        lastName: user?.lastName,
                                      })
                                    ]?.bg
                                  } ${
                                    colorClasses[
                                      getColorIndex({
                                        email: '',
                                        firstName: user?.firstName,
                                        lastName: user?.lastName,
                                      })
                                    ]?.text
                                  } w-8 h-8  flex items-center  justify-center rounded-full undefined font-semibold text-sm`}
                                >
                                  {getInitialsWithDots({
                                    firstName: user?.firstName,
                                    lastName: user?.lastName,
                                    email: '',
                                  })}
                                </div>
                                {user.firstName} {user.lastName}
                              </div>
                              <div>
                                <small className="text-[#4F4F4F]">
                                  {user?.roles?.[0] === 'BSO_ADVISOR'
                                    ? 'Advisor'
                                    : user?.roles?.[0] === 'BSO_ADMIN'
                                    ? 'Admin'
                                    : 'Admin'}
                                </small>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="px-3 py-2 text-gray-400">No users found</div>
                        )}
                      </div>
                    )}
                    <div className="flex items-center justify-between">
                      <div className="flex gap-2">
                        <img
                          onClick={() => setShowAttachmentPlay(true)}
                          src={require('../../../../appAssets/appImages/pin.png')}
                          alt=""
                          className="w-8 h-8 cursor-pointer"
                        />
                        <img
                          onClick={() => setShowEmojiPicker3(!showEmojiPicker3)}
                          src={require('../../../../appAssets/appImages/smiley.png')}
                          alt=""
                          className="w-8 h-8 cursor-pointer"
                        />
                        <img
                          onClick={handleAtClick}
                          src={require('../../../../appAssets/appImages/s1.png')}
                          alt=""
                          className="w-8 h-8 cursor-pointer"
                        />
                        {playsFiles && playsFiles?.length > 0 && (
                          <div
                            className="mt-1 cursor-pointer"
                            onClick={() => {
                              window.open(`${playsFiles[0]?.url}`, '_blank')
                            }}
                          >
                            <AppFileIconDouble />
                          </div>
                        )}
                      </div>
                      <div className="flex gap-2">
                        <button
                          className="px-4 py-1 border border-grey-darkest2x rounded-lg min-w-[87px]"
                          onClick={() => {
                            setPanelOpen(false)
                            setPlaysFiles([])
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          disabled={data?.length > 0 ? false : true}
                          className="px-3 py-2 bg-purple rounded-lg text-white flex min-w-[87px] items-center justify-center"
                          onClick={() => {
                            handleSummarySubmit(data, previousMettingById?.id, playsFiles)
                          }}
                        >
                          {isUpdateTranscriptSummary ? (
                            <div className="flex justify-center items-center gap-2">
                              <GradientCircleNotchIcon />
                            </div>
                          ) : (
                            'Save'
                          )}
                        </button>
                      </div>
                    </div>
                    {showEmojiPicker3 && (
                      <div className="absolute bottom-full left-0 z-10" ref={emojiPickerRef3}>
                        <AppEmojiPicker
                          onEmojiClick={onEmojiClick3}
                          isOpen={true}
                          onToggle={() => setShowEmojiPicker3(false)}
                          showEmojiIcon={false}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="mb-8 border border-[#ECECEC] rounded-lg px-4 py-4">
                <div className="flex justify-between items-center mb-0 border-b border-[#ECECEC] pb-3 md:flex-row flex-col">
                  <h6 className="text-md font-medium text-[#121212]">
                    Action Items <span className="text-sm font-normal">(Plays)</span>
                  </h6>
                  <button
                    onClick={() => setShowAddTaskModal(true)}
                    className="mt-4 md:mt-0 px-4 py-3 bg-purple rounded-lg text-white flex h-[48px]"
                  >
                    <span className="text-white text-sm">Add a Play</span>
                    <img
                      src={require('../../../../appAssets/appImages/plus-small.png')}
                      alt=""
                      className="w-6 cursor-pointer ml-2"
                    />
                  </button>
                </div>
                {showAddTaskModal && (
                  <AppModalBox
                    Icon={AppCrossIcon}
                    height="max-h-[835px] h-full"
                    width="max-w-2xl"
                    title={`Create new Play`}
                    showBorder={false}
                    onClose={() => {
                      setShowAddTaskModal(false)
                    }}
                    onBack={() => {
                      setShowAddTaskModal(false)
                    }}
                  >
                    <AppTask
                      meetingId={previousMettingById?.id}
                      tenantId={tenantId}
                      userId={userId}
                      plan={taskPlan}
                      source={UserTaskSource.Goal}
                      setShowTaskModal={setShowAddTaskModal}
                      setShowTaskSuccessModal={setShowAddTaskSuccessModal}
                      setShowTaskErrorModal={setShowAddTaskErrorModal}
                      setCreatedUserTask={setCreatedUserTask}
                      refetch={refetchUserTasks}
                      logo={logo ?? ''}
                      goalEndDate={goalEndDate!}
                      advisorsData={advisorsData}
                      userName={userName}
                      userAvatar={userAvatar ?? ''}
                      userFirstName={userFirstName ?? ''}
                      userLastName={userLastName ?? ''}
                      assigneeOptions={assigneeOptions}
                      paramUserId={userId}
                    />
                  </AppModalBox>
                )}
                {(showAddTaskSuccessModal || showAddTaskErrorModal) && (
                  <AppTaskCreationConfirmation
                    showAddTaskSuccessModal={showAddTaskSuccessModal}
                    setShowAddTaskModal={setShowAddTaskModal}
                    setShowAddTaskSuccessModal={setShowAddTaskSuccessModal}
                    setShowAddTaskErrorModal={setShowAddTaskErrorModal}
                    createdUserTask={createdUserTask}
                    userId={userId}
                    userAvatar={userAvatar ?? ''}
                    userFirstName={userFirstName ?? ''}
                    userLastName={userLastName ?? ''}
                  />
                )}

                {meetingData?.getUserMeetingTasks?.map((item, idx) => {
                  const fullName = item?.createdBy || ''
                  const [firstName, ...rest] = fullName.trim().split(' ')
                  const lastName = rest.join(' ')
                  return (
                    <div
                      key={idx}
                      className="bg-white p-4 py-6 pb-5 mb-0 border-b border-[#E4E4E7] relative last:border-0"
                    >
                      <div className="absolute top-5 right-2 flex space-x-2">
                        <img
                          onClick={() => {
                            setSelectedTask(item as ITaskSummaryItem)
                            setShowTaskDetails(true)
                          }}
                          src={require('../../../../appAssets/appImages/edit.png')}
                          alt=""
                          className="w-6 h-6 cursor-pointer"
                        />
                        <img
                          onClick={() => onDeleteActionItem(item?.taskId, previousMettingById?.id)}
                          src={require('../../../../appAssets/appImages/remove.png')}
                          alt=""
                          className="w-6 h-6 cursor-pointer"
                        />
                      </div>

                      <p className="text-[#121212] text-md mb-2 ">{item?.name}</p>

                      <p className="text-[#5E5E5E] text-md mb-2 pr-8">
                        {item?.instructionForTask || item?.howToDo}
                      </p>
                      <div className="flex items-center space-x-2 mb-2 mt-4 justify-end absolute right-2 top-[65px]">
                        <span
                          className={` ${
                            colorClasses[
                              getColorIndex({
                                email: '',
                                firstName: firstName,
                                lastName: lastName,
                              })
                            ]?.bg
                          } ${
                            colorClasses[
                              getColorIndex({
                                email: '',
                                firstName: firstName,
                                lastName: lastName,
                              })
                            ]?.text
                          } w-8 h-8 rounded-full  text-center items-center justify-center  text-[16px] font-medium flex capitalize absolute`}
                        >
                          {getInitialsWithDots({
                            firstName: firstName,
                            lastName: lastName,
                            email: '',
                          })}
                        </span>
                      </div>

                      <div className="flex space-x-2 text-md ">
                        <span className="text-grey-darkest bg-grey-lighter3x rounded-lg px-2 py-1">
                          {toTitleCase(item?.category?.replace(/_/g, ' '))}
                        </span>
                        {item?.taskPriority === 'HIGH_PRIORITY' ? (
                          <span className="text-app-red-70 bg-app-red-20 rounded-lg px-2 py-1">
                            High
                          </span>
                        ) : item?.taskPriority === 'MEDIUM_PRIORITY' ? (
                          <span className="text-orange bg-yellow-lighter2x rounded-lg px-2 py-1">
                            Medium
                          </span>
                        ) : (
                          <span className=" bg-app-green-30 rounded-lg px-2 py-1 text-green-dark">
                            Low
                          </span>
                        )}
                      </div>
                      <div className="flex space-x-2 text-md mt-3">
                        <span className="text-grey-darkest bg-grey-lighter3x rounded-lg px-2 py-1">
                          {moment(item?.startDate).format('MMMM DD, YYYY')}
                        </span>
                        <span> - </span>
                        <span
                          className={
                            item?.taskPriority === 'HIGH_PRIORITY'
                              ? 'text-app-red-70 bg-app-red-20 rounded-lg px-2 py-1'
                              : item?.taskPriority === 'MEDIUM_PRIORITY'
                              ? 'text-orange bg-yellow-lighter2x rounded-lg px-2 py-1'
                              : ' bg-app-green-20 rounded-lg px-2 py-1 text-app-green-70'
                          }
                        >
                          {moment(item?.expectedEndDate).format('MMMM DD, YYYY')}
                        </span>
                      </div>
                    </div>
                  )
                })}
              </div>
              {showTaskDetails && selectedTask && (
                <AppModalBox
                  Icon={AppCrossIcon}
                  height="max-h-[835px] h-full"
                  width="max-w-2xl"
                  showBorder={false}
                  title={`${
                    selectedTask.category ? `${categoryType[selectedTask.category]} /` : ' '
                  } ${selectedTask?.name ?? ''} `}
                  titleSize="sm"
                  onClose={() => {
                    setShowTaskDetails(false)
                    setSelectedTask(null)
                  }}
                  onBack={() => {
                    setShowTaskDetails(false)
                    setSelectedTask(null)
                  }}
                >
                  <AppTask
                    setFileDeleteSuccess={setFileDeleteSuccess}
                    setIsUpdateTaskSuccess={setIsUpdateTaskSuccess}
                    setShowTaskSuccessModal={setShowAddTaskSuccessModal}
                    meetingId={previousMettingById?.id}
                    task={selectedTask}
                    logo={logo ?? ''}
                    tenantId={selectedTask.tenantId ?? ''}
                    source={UserTaskSource.Goal}
                    setShowTaskModal={setShowTaskDetails}
                    refetch={refetchMeetingTask}
                    userId={selectedTask.userId ?? ''}
                    userName={userName}
                    advisorsData={advisorsData}
                    plan={{
                      name: selectedTask.planName,
                      id: selectedTask.planId,
                      planExpectedEndDate: selectedTask.planExpectedEndDate,
                    }}
                    goalEndDate={selectedTask.goalEndDate ?? ''}
                    userAvatar={userAvatar ?? ''}
                    userFirstName={userFirstName ?? ''}
                    userLastName={userLastName ?? ''}
                    goalId={selectedTask.goalId ?? ''}
                    assigneeOptions={assigneeOptions}
                    hoursSpentPerDay={hoursSpentPerDay}
                    paramUserId={selectedTask.userId ?? ''}
                  />
                </AppModalBox>
              )}
              {/* Private Notes */}

              <div className="mb-8 border border-[#ECECEC] rounded-lg px-4 py-4 bg-[#FBFBFB]">
                <div className="flex justify-between items-center mb-1 pb-3 md:flex-row flex-col border-b border-[#ECECEC]">
                  <h6 className="text-md font-medium text-[#121212]">
                    Private Notes{' '}
                    <span className="text-md font-normal">
                      {isUserBusinessOwner()
                        ? '(Notes are only visible to you)'
                        : '(Notes are not visible to clients)'}
                    </span>
                  </h6>
                  <button
                    className="mt-4 md:mt-0 px-6 py-3 bg-purple  rounded-lg text-white flex items-center h-[48px]"
                    onClick={() => setOpenNote(true)}
                  >
                    <span className="text-white text-sm">Create a note</span>
                    <img
                      src={require('../../../../appAssets/appImages/plus-small.png')}
                      alt=""
                      className="w-[20px] cursor-pointer ml-2"
                    />
                  </button>
                </div>
                {openNote && (
                  <div className="relative mb-4 bg-gray-100 rounded-lg mt-4">
                    <div className="border border-[#DBDBDB] rounded-lg px-4 py-4 bg-[#fff]">
                      <textarea
                        defaultValue={privateNote}
                        value={privateNote}
                        ref={privateNoteRef}
                        onChange={handleChangeAddNote}
                        placeholder="Write your notes"
                        className="w-full p-2 mb-4 focus:outline-0"
                      ></textarea>
                      {showMentionListAddNote && (
                        <div
                          ref={mentionPickerAddNoteRef}
                          className="absolute bg-white shadow-lg rounded-lg border border-[#ececec] mt-1 max-h-40 overflow-auto z-20 w-80"
                        >
                          {filteredUsers.length > 0 ? (
                            filteredUsers.map((user) => (
                              <div
                                key={user.id}
                                className="px-3 py-2 cursor-pointer hover:bg-gray-100 flex items-center gap-3 justify-between"
                                onClick={() => handleUserSelectAddNote(user)}
                              >
                                <div className="flex items-center gap-3 text-sm">
                                  <div
                                    className={`${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: user?.firstName,
                                          lastName: user?.lastName,
                                        })
                                      ]?.bg
                                    } ${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: user?.firstName,
                                          lastName: user?.lastName,
                                        })
                                      ]?.text
                                    } w-8 h-8  flex items-center  justify-center rounded-full undefined font-semibold text-sm`}
                                  >
                                    {getInitialsWithDots({
                                      firstName: user?.firstName,
                                      lastName: user?.lastName,
                                      email: '',
                                    })}
                                  </div>
                                  {user.firstName} {user.lastName}
                                </div>
                                <div>
                                  <small className="text-[#4F4F4F]">
                                    {user?.roles?.[0] === 'BSO_ADVISOR'
                                      ? 'Advisor'
                                      : user?.roles?.[0] === 'BSO_ADMIN'
                                      ? 'Admin'
                                      : 'Admin'}
                                  </small>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="px-3 py-2 text-gray-400">No users found</div>
                          )}
                        </div>
                      )}
                      <div className="flex items-center justify-between">
                        <div className="flex gap-1">
                          <img
                            onClick={() => {
                              setShowAttachment(true)
                            }}
                            src={require('../../../../appAssets/appImages/pin.png')}
                            alt=""
                            className="w-8 h-8 cursor-pointer"
                          />
                          <img
                            onClick={() => setShowEmojiPicker2(!showEmojiPicker2)}
                            src={require('../../../../appAssets/appImages/smiley.png')}
                            alt=""
                            className="w-8 h-8 cursor-pointer"
                          />

                          {!isBusinessOwner && (
                            <img
                              onClick={handleAtClickAddNote}
                              src={require('../../../../appAssets/appImages/s1.png')}
                              alt=""
                              className="w-8 h-8 cursor-pointer"
                            />
                          )}
                          {privateNoteFiles && privateNoteFiles?.length > 0 && (
                            <div
                              className="mt-1 cursor-pointer"
                              onClick={() => {
                                window.open(`${privateNoteFiles[0]?.url}`, '_blank')
                              }}
                            >
                              <AppFileIconDouble />
                            </div>
                          )}
                        </div>
                        <div className="flex gap-2">
                          <button
                            className="px-4 py-1 border border-grey-darkest2x rounded-lg min-w-[87px] text-center"
                            onClick={() => {
                              setOpenNote(false)
                              setPrivateNoteFiles([])
                              setPrivateNote('')
                              setTaggedId([])
                            }}
                          >
                            Cancel
                          </button>

                          <button
                            className="px-3 py-2 bg-purple rounded-lg text-white flex min-w-[87px] items-center justify-center"
                            onClick={() => {
                              handleFormSubmit(
                                privateNote,
                                previousMettingById?.id,
                                previousMettingById?.ownerId,

                                users?.user.id,
                                privateNoteFiles,
                                taggedId
                              )
                            }}
                          >
                            {isAddPrivateNoteLoading ? (
                              <div className="flex justify-center items-center gap-2">
                                <GradientCircleNotchIcon />
                              </div>
                            ) : (
                              'Save'
                            )}
                          </button>
                        </div>
                      </div>
                      {showEmojiPicker2 && (
                        <div className="absolute bottom-full left-0 z-10" ref={emojiPickerRef2}>
                          <AppEmojiPicker
                            onEmojiClick={onEmojiClick2}
                            isOpen={true}
                            onToggle={() => setShowEmojiPicker2(false)}
                            showEmojiIcon={false}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {previousMettingById?.privateNotes?.map((note, idx) => (
                  <React.Fragment key={idx}>
                    {showTextareaIndex !== idx && (
                      <div className="bg-gray-50 p-4 py-5 mb-2 flex space-x-4 justify-between border-b border-[#E4E4E7] items-center last:border-b-0">
                        <div>
                          <p className="text-grey-darkest1x">
                            {renderNoteWithMentions(note?.content, allUsers)}
                          </p>

                          <p className="text-gray-600 text-sm">
                            <p className="mt-1">
                              <span className="text-md text-grey-darker">
                                {users?.user?.id === note?.createdBy
                                  ? 'You'
                                  : getUserNameById(note?.createdBy)}
                                &nbsp;-&nbsp;{timeAgo(note?.createdAt)}
                              </span>
                            </p>
                          </p>
                        </div>
                        <div className="flex space-x-2">
                          <img
                            style={{
                              display: users?.user?.id === note?.createdBy ? 'flex' : 'none',
                            }}
                            onClick={() => handleAddTextarea(idx, note?.content)}
                            src={require('../../../../appAssets/appImages/edit.png')}
                            alt=""
                            className="w-6 h-6 cursor-pointer"
                          />
                          {note?.files && note?.files.length > 0 && (
                            <div
                              className="cursor-pointer"
                              onClick={() => {
                                window.open(`${note?.files[0]?.url}`, '_blank')
                              }}
                            >
                              <AppFileIconDouble />
                            </div>
                          )}
                          <img
                            style={{
                              display: users?.user?.id === note?.createdBy ? 'flex' : 'none',
                            }}
                            onClick={() => onDeleteClick(note?.noteId, previousMettingById?.id)}
                            src={require('../../../../appAssets/appImages/remove.png')}
                            alt=""
                            className="w-6 h-6 cursor-pointer"
                          />
                        </div>
                      </div>
                    )}

                    {showTextareaIndex === idx && (
                      <div
                        ref={mentionPickerUpdateNoteRef}
                        className="relative mb-8 bg-gray-100 rounded-lg px-4 py-4 border border-grey-darkest2x"
                      >
                        <textarea
                          ref={textAreaRef}
                          value={noteText}
                          onChange={handleChangeUpdateNote}
                          placeholder="Write your notes"
                          className="w-full p-2 mb-4 focus:outline-0"
                        ></textarea>
                        {showMentionListUpdateNote && (
                          <div
                            ref={mentionPickerUpdateNoteRef}
                            className="absolute bg-white shadow-lg rounded-lg border border-[#ececec] mt-1 max-h-40 overflow-auto z-20 w-80"
                          >
                            {filteredUsers.length > 0 ? (
                              filteredUsers.map((user) => (
                                <div
                                  key={user.id}
                                  className="px-3 py-2 cursor-pointer hover:bg-gray-100 flex items-center gap-3 justify-between"
                                  onClick={() => handleUserSelectUpdateNote(user)}
                                >
                                  <div className="flex items-center gap-3 text-sm">
                                    <div
                                      className={`${
                                        colorClasses[
                                          getColorIndex({
                                            email: '',
                                            firstName: user?.firstName,
                                            lastName: user?.lastName,
                                          })
                                        ]?.bg
                                      } ${
                                        colorClasses[
                                          getColorIndex({
                                            email: '',
                                            firstName: user?.firstName,
                                            lastName: user?.lastName,
                                          })
                                        ]?.text
                                      } w-8 h-8  flex items-center  justify-center rounded-full undefined font-semibold text-sm`}
                                    >
                                      {getInitialsWithDots({
                                        firstName: user?.firstName,
                                        lastName: user?.lastName,
                                        email: '',
                                      })}
                                    </div>
                                    {user.firstName} {user.lastName}
                                  </div>
                                  <div>
                                    <small className="text-[#4F4F4F]">
                                      {user?.roles?.[0] === 'BSO_ADVISOR'
                                        ? 'Advisor'
                                        : user?.roles?.[0] === 'BSO_ADMIN'
                                        ? 'Admin'
                                        : 'Admin'}
                                    </small>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="px-3 py-2 text-gray-400">No users found</div>
                            )}
                          </div>
                        )}
                        <div className="flex items-center justify-between">
                          <div className="flex gap-1">
                            <img
                              onClick={() => setShowAttachment(true)}
                              src={require('../../../../appAssets/appImages/pin.png')}
                              alt=""
                              className="w-8 h-8 cursor-pointer"
                            />
                            <img
                              onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                              src={require('../../../../appAssets/appImages/smiley.png')}
                              alt=""
                              className="w-8 h-8 cursor-pointer"
                            />
                            {note?.files && note?.files.length > 0 && (
                              <div
                                className="cursor-pointer"
                                onClick={() => {
                                  window.open(`${note?.files[0]?.url}`, '_blank')
                                }}
                              >
                                <AppFileIconDouble />
                              </div>
                            )}
                            {!isBusinessOwner && (
                              <img
                                onClick={handleAtClickUpdateNote}
                                src={require('../../../../appAssets/appImages/s1.png')}
                                alt=""
                                className="w-8 h-8 cursor-pointer"
                              />
                            )}
                          </div>
                          <div className="flex gap-2">
                            <button
                              className="px-4 py-1 border border-grey-darkest2x rounded-lg min-w-[87px]"
                              onClick={() => {
                                setShowTextareaIndex(null)
                                setPrivateNoteFiles([])
                                setTaggedId([])
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              disabled={!noteText && true}
                              className="px-3 py-2 bg-purple rounded-lg text-white flex min-w-[87px] justify-center items-center"
                              onClick={() => {
                                handleUpdateSubmit(
                                  noteText,
                                  note?.noteId,
                                  previousMettingById?.id,
                                  previousMettingById?.ownerId,
                                  users?.user?.id,
                                  privateNoteFiles,
                                  taggedId
                                )
                              }}
                            >
                              {isUpdatePrivateNoteLoading ? (
                                <div className="flex justify-center items-center gap-2">
                                  <GradientCircleNotchIcon />
                                </div>
                              ) : (
                                'Save'
                              )}
                            </button>
                          </div>
                        </div>
                        {showEmojiPicker && (
                          <div className="absolute bottom-full left-0 z-10" ref={emojiPickerRef}>
                            <AppEmojiPicker
                              onEmojiClick={onEmojiClick}
                              isOpen={true}
                              onToggle={() => setShowEmojiPicker(false)}
                              showEmojiIcon={false}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </React.Fragment>
                ))}

                {openThread && (
                  <div className="relative mb-8 bg-gray-100 rounded-lg">
                    <div className="border border-grey-darkest2x rounded-lg px-4 py-4">
                      <textarea
                        placeholder="Write your notes"
                        className="w-full p-2 mb-4 focus:outline-0"
                      ></textarea>
                      <div className="flex items-center justify-between">
                        <div className="flex gap-2">
                          <img
                            src={require('../../../../appAssets/appImages/pin.png')}
                            alt=""
                            className="w-5 h-5 cursor-pointer"
                          />
                          <img
                            src={require('../../../../appAssets/appImages/smiley.png')}
                            alt=""
                            className="w-5 h-5 cursor-pointer"
                          />
                          <img
                            src={require('../../../../appAssets/appImages/s1.png')}
                            alt=""
                            className="w-5 h-5 cursor-pointer"
                          />
                        </div>
                        <div className="flex gap-2">
                          <button
                            className="px-4 py-1 border border-grey-darkest2x rounded-lg min-w-[87px]"
                            onClick={() => setOpenThread(false)}
                          >
                            Cancel
                          </button>
                          <button
                            className="px-3 py-2 bg-purple rounded-lg text-white flex min-w-[87px] justify-center items-center"
                            onClick={() => {
                              setOpenThread(false)
                            }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>
        </>
      ) : (
        <>
          {filter.includes('upcoming') && (
            <>
              {meetingDataLoading && (
                <div className="mt-4 space-y-2">
                  <div className="flex justify-center items-center gap-2">
                    <GradientCircleNotchIcon width="100" height="100" />
                  </div>
                </div>
              )}
              {(() => {
                let lastMonth = ''
                return upcomingMeetingList.map((upcoming: any, idx: any) => {
                  const meetingDate = moment.tz(upcoming.start, user.timezone).toDate()

                  const day = meetingDate.getDate()
                  const week = meetingDate.toLocaleString('default', { weekday: 'long' })
                  const month = meetingDate.toLocaleString('default', { month: 'long' })
                  const showMonth = month !== lastMonth
                  lastMonth = month
                  const time = upcoming.time

                  return (
                    <>
                      <section
                        data-testid="meeting-title"
                        key={idx}
                        className="pb-6 font-sans bg-gray-50 text-gray-800 px-5 md:px-0"
                      >
                        <div className="mx-auto">
                          <div className="space-y-8">
                            <div>
                              {showMonth && <h6 className="text-lg font-medium mb-4">{month}</h6>}
                              <div className="flex flex-col gap-6">
                                <div
                                  className={
                                    openUpcomingDropdownIds[upcoming.id]
                                      ? 'flex flex-col md:flex-row justify-between items-start pl-2 p-4 bg-[#F7F7FF] rounded-lg border border-[#ECECEC] items-center border-purple'
                                      : 'flex flex-col md:flex-row justify-between items-start pl-2 p-4 bg-white rounded-lg border border-[#ECECEC] items-center'
                                  }
                                >
                                  <div className="flex gap-4 ">
                                    <div className="text-center w-24 border-e border-[#ECECEC] leading-[40px]">
                                      <p className="text-[16px] landing-[40px] text-gray-500 text-[#71717A]">
                                        {week.substring(0, 3)}
                                      </p>
                                      <span className="text-[40px] landing-[40px] font-medium text-[#71717A]">
                                        {day}
                                      </span>
                                    </div>
                                    <div className="ps-6">
                                      <h6 className="font-medium flex items-center gap-2 text-md mb-2">
                                        {upcoming?.title || 'NA'}
                                      </h6>
                                      <p className="text-sm text-[#5E5E5E]">
                                        {time} {moment().tz(upcoming?.timezone).format('z')}
                                      </p>
                                      <div className="flex mt-2">
                                        <span
                                          className={` ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: upcoming?.organizerDetail?.firstName,
                                                lastName: upcoming?.organizerDetail?.lastName,
                                              })
                                            ]?.bg
                                          } ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: upcoming?.organizerDetail?.firstName,
                                                lastName: upcoming?.organizerDetail?.lastName,
                                              })
                                            ]?.text
                                          }  w-8 h-8 text-[14px] ml-[-5px] rounded-full  text-center items-center justify-center flex capitalize  border border-[#fff] [&:nth-child(1)]:-ml-[0px]`}
                                        >
                                          {getInitialsWithDots({
                                            firstName: upcoming?.organizerDetail?.firstName,
                                            lastName: upcoming?.organizerDetail?.lastName,
                                            email: '',
                                          })}
                                        </span>
                                        <span
                                          className={` ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: upcoming?.participantDetail?.firstName,
                                                lastName: upcoming?.participantDetail?.lastName,
                                              })
                                            ]?.bg
                                          } ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: upcoming?.participantDetail?.firstName,
                                                lastName: upcoming?.participantDetail?.lastName,
                                              })
                                            ]?.text
                                          } w-8 h-8 text-[14px] ml-[-5px] rounded-full  text-center items-center justify-center flex capitalize  border border-[#fff] [&:nth-child(1)]:-ml-[0px]`}
                                        >
                                          {getInitialsWithDots({
                                            firstName: upcoming?.participantDetail?.firstName,
                                            lastName: upcoming?.participantDetail?.lastName,
                                            email: '',
                                          })}
                                        </span>
                                        {[...new Set(upcoming?.attendeesEmail)].map((email) => (
                                          <span
                                            className={`${
                                              colorClasses[
                                                getColorIndex({
                                                  email: typeof email === 'string' ? email : '',
                                                  firstName: '',
                                                  lastName: '',
                                                })
                                              ]?.bg
                                            } ${
                                              colorClasses[
                                                getColorIndex({
                                                  email: typeof email === 'string' ? email : '',
                                                  firstName: '',
                                                  lastName: '',
                                                })
                                              ]?.text
                                            } w-8 h-8 text-[14px] ml-[-5px] rounded-full text-center items-center justify-center flex capitalize  border border-[#fff] [&:nth-child(1)]:-ml-[0px]`}
                                          >
                                            {getInitialsWithDots({
                                              firstName: '',
                                              lastName: '',
                                              email: typeof email === 'string' ? email : '',
                                            })}
                                          </span>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex items-end gap-2 justify-between align-middle w-auto items-center">
                                    <div className="relative inline-block text-right">
                                      <button
                                        onClick={() => toggleUpcomingDropdown(upcoming.id)}
                                        className={
                                          openUpcomingDropdownIds[upcoming.id]
                                            ? 'inline-flex justify-center text-white items-center px-4 py-2 text-sm font-medium bg-purple rounded-lg hover:bg-gray-300 border border-grey-lighter4x min-w-[90px] h-[48px]'
                                            : 'inline-flex justify-center text-black items-center px-4 py-2 text-sm font-medium bg-white rounded-lg hover:bg-gray-300 border border-[#DBDBDB] min-w-[90px] h-[48px]'
                                        }
                                      >
                                        Edit{' '}
                                        <img
                                          className="ml-2"
                                          width={20}
                                          src={
                                            !openUpcomingDropdownIds[upcoming.id]
                                              ? require('../../../../appAssets/appImages/chevron-down.png')
                                              : require('../../../../appAssets/appImages/chevron-up.png')
                                          }
                                          alt="down"
                                        />
                                      </button>
                                      {openUpcomingDropdownIds[upcoming.id] && (
                                        <div
                                          className="absolute right-0 z-10 mt-2 min-w-[225px] origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                          tabIndex={-1}
                                          ref={(el) => {
                                            // Use a closure to manage the event listener
                                            if (!el) return
                                            const handleClick = (event: MouseEvent) => {
                                              if (!el.contains(event.target as Node)) {
                                                setOpenUpcomingDropdownIds((prev) => ({
                                                  ...prev,
                                                  [upcoming.id]: false,
                                                }))
                                                document.removeEventListener(
                                                  'mousedown',
                                                  handleClick
                                                )
                                              }
                                            }
                                            document.addEventListener('mousedown', handleClick)
                                          }}
                                          onBlur={() => {
                                            setOpenUpcomingDropdownIds((prev) => ({
                                              ...prev,
                                              [upcoming.id]: false,
                                            }))
                                          }}
                                        >
                                          <div className=" pt-2">
                                            <div className="pl-1">
                                              <button
                                                onClick={() => {
                                                  setRescheduleAppointId(upcoming)
                                                  const start = upcoming?.start
                                                    ? new Date(upcoming.start)
                                                    : null
                                                  const end = upcoming?.end
                                                    ? new Date(upcoming.end)
                                                    : null

                                                  const isValidDate = (date: any) =>
                                                    date instanceof Date && !isNaN(date.getTime())

                                                  const durationMs =
                                                    isValidDate(start) &&
                                                    isValidDate(end) &&
                                                    end &&
                                                    start
                                                      ? end.getTime() - start.getTime()
                                                      : 0

                                                  const durationMinute =
                                                    durationMs > 0 ? durationMs / (1000 * 60) : 0

                                                  setSelectedDuration(durationMinute)
                                                }}
                                                className="w-full text-left px-2 py-2 text-sm text-gray-700 hover:bg-gray-100 flex"
                                              >
                                                <img
                                                  src={require('../../../../appAssets/appImages/time.png')}
                                                  alt="time"
                                                  width={20}
                                                  className="mr-2"
                                                />
                                                Reschedule Appointment
                                              </button>

                                              <button
                                                onClick={() => {
                                                  setInviteMeetingId(upcoming)
                                                  setInviteMeetingData(upcoming)
                                                }}
                                                className="w-full text-left px-2 py-2 text-sm text-gray-700 hover:bg-gray-100 flex"
                                              >
                                                <img
                                                  src={require('../../../../appAssets/appImages/user-plus.png')}
                                                  alt="Invite People"
                                                  width={20}
                                                  className="mr-2"
                                                />
                                                Invite People
                                              </button>
                                            </div>
                                            <div className="border-t border-[#ECECEC]"></div>
                                            <div className="pl-1 py-2">
                                              <button
                                                onClick={() => {
                                                  setSelectedMeeting(upcoming)
                                                  setShowModal(true)
                                                }}
                                                className="w-full text-left px-2 py-2 text-sm text-red-600 hover:bg-gray-100 flex"
                                              >
                                                <img
                                                  src={require('../../../../appAssets/appImages/x-circle.png')}
                                                  alt="Cancel Appointment"
                                                  width={20}
                                                  className="mr-2"
                                                />
                                                Cancel Appointment
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                      {inviteMeetingId && inviteMeetingId.id === upcoming.id && (
                                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                                          <div className="bg-white w-full max-w-lg mx-auto rounded-[16px] shadow-lg">
                                            {/* Header */}
                                            <div className="flex justify-between items-center  p-6 border-b border-[#ECECEC]">
                                              <img
                                                src={require('../../../../appAssets/appImages/arrow-left.png')}
                                                alt="arrow"
                                                width={20}
                                                onClick={() => {
                                                  setInviteMeetingId(null)
                                                  setInvitedEmails([])
                                                  setSearchQuery('')
                                                  setAttendee([])
                                                }}
                                              />
                                              <button
                                                onClick={() => {
                                                  setInviteMeetingId(null)
                                                  setInvitedEmails([])
                                                  setSearchQuery('')
                                                  setAttendee([])
                                                }}
                                                className="text-gray-500 hover:text-gray-700"
                                              >
                                                <img
                                                  src={require('../../../../appAssets/appImages/x-mark.png')}
                                                  alt="close"
                                                  width={20}
                                                />
                                              </button>
                                            </div>
                                            <div className="text-left p-6 ">
                                              <h2 className="text-lg font-semibold text-[#121212]">
                                                Invite members
                                              </h2>
                                              {/* Subheading */}
                                              <p className="text-sm text-[#5E5E5E] mb-0">
                                                {`Invite participants to "${
                                                  inviteMeetingId?.title
                                                }" on ${moment(inviteMeetingId?.start).format(
                                                  'DD/MM/YYYY'
                                                )}`}
                                              </p>
                                            </div>
                                            <hr className="border-[#ECECEC]" />

                                            {/* Email Input */}
                                            <div className="text-left p-6 pb-0">
                                              <label className="text-sm text-[#121212]">
                                                Enter email address
                                              </label>
                                              <div className="w-full mb-6 mt-2">
                                                <div className="w-full flex gap-2 mb-2">
                                                  <input
                                                    type="email"
                                                    placeholder="name@company.com"
                                                    className="w-full px-4 py-2 border border-[#DBDBDB] focus:outline-none focus:border-[#705AF8] rounded-lg text-sm"
                                                    value={emailInput}
                                                    onChange={(e) => setEmailInput(e.target.value)}
                                                    onKeyDown={(e) => {
                                                      if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        handleInvite()
                                                      }
                                                    }}
                                                  />
                                                  <button
                                                    disabled={attendee.length > 0 ? false : true}
                                                    onClick={InviteUsersMutate}
                                                    className={
                                                      invitedEmails.length > 0
                                                        ? 'bg-purple hover:bg-violet-700 text-white text-sm font-medium px-4 py-2 rounded-lg cursor-pointer'
                                                        : 'bg-[#DBDBDB] hover:bg-violet-700 text-[#ffff] text-sm font-medium px-4 py-2 rounded-lg'
                                                    }
                                                  >
                                                    {isUpdateUserCalendarEventLoading ? (
                                                      <div className="flex justify-center items-center gap-2">
                                                        <GradientCircleNotchIcon />
                                                      </div>
                                                    ) : (
                                                      'Invite'
                                                    )}
                                                  </button>
                                                </div>
                                                <div className="flex flex-wrap gap-2 pt-0 pb-0">
                                                  {[
                                                    // Combine already-invited and newly-invited, remove duplicates
                                                    ...(Array.isArray(
                                                      inviteMeetingId?.attendeesEmail
                                                    )
                                                      ? inviteMeetingId.attendeesEmail.map(
                                                          (email) => {
                                                            const user = allInviteUsers.find(
                                                              (u) => u.email === email
                                                            )
                                                            return user
                                                              ? { ...user, source: 'already' }
                                                              : {
                                                                  email,
                                                                  firstName: '',
                                                                  lastName: '',
                                                                  source: 'already',
                                                                }
                                                          }
                                                        )
                                                      : []),
                                                    ...invitedEmails.map((user) => ({
                                                      ...user,
                                                      source: 'new',
                                                    })),
                                                  ]
                                                    // Remove duplicates by email
                                                    .filter(
                                                      (user, index, self) =>
                                                        self.findIndex(
                                                          (u) => u.email === user.email
                                                        ) === index
                                                    )
                                                    .map((user) => (
                                                      <div
                                                        key={user.email}
                                                        className="flex items-center bg-[#EAE9FE] text-[#5C37EB] px-2 py-1 rounded-lg text-sm"
                                                      >
                                                        {user.firstName || user.lastName
                                                          ? `${user.firstName} ${
                                                              user.lastName || ''
                                                            }`
                                                          : user.email}
                                                        <button
                                                          onClick={() => handleRemoveEmail(user)}
                                                          className="mx-2 text-lg"
                                                        >
                                                          &times;
                                                        </button>
                                                      </div>
                                                    ))}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Members List */}
                                            <ul className="space-y-4 pt-0 p-6 pb-6">
                                              <div className="text-left sticky">
                                                <label className="text-sm text-[#121212]">
                                                  Select from contacts
                                                </label>
                                                <div className="flex items-center gap-2 mb-6 mt-2">
                                                  <input
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    type="email"
                                                    placeholder="Search contacts"
                                                    className="flex-1 px-4 py-2 border border-[#DBDBDB] rounded-lg text-sm focus:outline-none focus:border-[#705AF8]"
                                                  />
                                                </div>
                                              </div>
                                              <div className="space-y-4 h-[140px] overflow-auto">
                                                {filteredContacts.map((member, index) => (
                                                  <li
                                                    key={index}
                                                    className=" cursor-pointer flex justify-between items-center"
                                                  >
                                                    <div className="flex items-center gap-3">
                                                      <div className="flex items-center">
                                                        <input
                                                          disabled={
                                                            Array.isArray(
                                                              inviteMeetingId?.attendeesEmail
                                                            )
                                                              ? inviteMeetingId.attendeesEmail.includes(
                                                                  member.email
                                                                )
                                                              : false
                                                          }
                                                          //className="appearance-none w-5 h-5 border border-[#DBDBDB] checked:bg-[#705AF8] checked:border-[#705AF8] rounded-md"
                                                          type="checkbox"
                                                          checked={
                                                            invitedEmails.some(
                                                              (e) => e.email === member.email
                                                            ) ||
                                                            (Array.isArray(
                                                              inviteMeetingId?.attendeesEmail
                                                            ) &&
                                                              inviteMeetingId.attendeesEmail.includes(
                                                                member.email
                                                              ))
                                                          }
                                                          className={`appearance-none cursor-pointer w-5 h-5 rounded-md border border-[#705AF8]
                                                          ${
                                                            invitedEmails.some(
                                                              (e) => e.email === member.email
                                                            ) ||
                                                            (Array.isArray(
                                                              inviteMeetingId?.attendeesEmail
                                                            ) &&
                                                              inviteMeetingId.attendeesEmail.includes(
                                                                member.email
                                                              ))
                                                              ? " !bg-[#705AF8] !bg-[url('assets/svgs/WhiteTick.svg')] !bg-no-repeat !bg-center"
                                                              : ''
                                                          }
                                                          `}
                                                          onChange={() =>
                                                            handleCheckboxChange(member)
                                                          }
                                                        />
                                                      </div>
                                                      {member?.avatar ? (
                                                        <img
                                                          alt=""
                                                          src={member?.avatar}
                                                          className="w-8 h-8 bg-gray-300 rounded-full"
                                                        />
                                                      ) : (
                                                        <div
                                                          className={` ${
                                                            colorClasses[
                                                              getColorIndex({
                                                                email: member?.email,
                                                                firstName: member?.firstName,
                                                                lastName: '',
                                                              })
                                                            ]?.bg
                                                          } ${
                                                            colorClasses[
                                                              getColorIndex({
                                                                email: member?.email,
                                                                firstName: member?.firstName,
                                                                lastName: '',
                                                              })
                                                            ]?.text
                                                          } w-8 h-8 flex items-center  justify-center rounded-full  font-semibold text-sm`}
                                                        >
                                                          {getInitialsWithDots({
                                                            firstName: member?.firstName,
                                                            lastName: member?.lastName,
                                                            email: member?.email,
                                                          })}
                                                        </div>
                                                      )}
                                                      <div>
                                                        <div className="text-sm font-medium text-gray-800">
                                                          {`${member?.firstName} ${member?.lastName}`}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="text-sm text-[#5E5E5E]">
                                                      {member?.roles[0] === 'BSO_ADVISOR'
                                                        ? 'Advisor'
                                                        : member?.roles[0] === 'BSO_ADMIN'
                                                        ? 'Admin'
                                                        : 'Team Member'}
                                                    </div>
                                                  </li>
                                                ))}
                                              </div>
                                            </ul>
                                          </div>
                                        </div>
                                      )}

                                      {rescheduleAppointId &&
                                        rescheduleAppointId.id === upcoming.id && (
                                          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                                            <div className="bg-white w-full max-w-lg mx-auto rounded-[16px] shadow-lg">
                                              {/* Header */}
                                              <div className="flex justify-between items-center  p-6 pb-4 relative min-h-[69px]">
                                                {meetingStepper !== MEETING_STEPPER.ADVISOR && (
                                                  <div className="flex items-center gap-2">
                                                    <img
                                                      src={require('../../../../appAssets/appImages/chevron-left.png')}
                                                      alt="arrow"
                                                      width={20}
                                                      onClick={() => {
                                                        dispatch(
                                                          updateMeetingStepperAction({
                                                            actionType: 'decrement',
                                                          })
                                                        )
                                                      }}
                                                    />
                                                    <h2 className="text-lg font-semibold text-[#3F3F46]">
                                                      {meetingStepper === MEETING_STEPPER.ADVISOR
                                                        ? 'Schedule Meeting'
                                                        : meetingStepper ===
                                                          MEETING_STEPPER.CALENDAR
                                                        ? 'Select a Date'
                                                        : meetingStepper === MEETING_STEPPER.SLOTS
                                                        ? 'Select a Time'
                                                        : 'Confirm Meeting'}
                                                    </h2>
                                                  </div>
                                                )}
                                                <button
                                                  onClick={() => {
                                                    setSelectedClient(null)
                                                    setSelectedAdvisor(null)
                                                    setRescheduleAppointId([])
                                                    dispatch(
                                                      updateMeetingStepperAction({
                                                        actionType: 'reset',
                                                        stepName: MEETING_STEPPER.ADVISOR,
                                                      })
                                                    )

                                                    setSelectedDuration(null)
                                                  }}
                                                  className="text-gray-500 text-end hover:text-gray-700 absolute right-[20px]"
                                                >
                                                  <img
                                                    src={require('../../../../appAssets/appImages/x-mark.png')}
                                                    alt="close"
                                                    width={20}
                                                  />
                                                </button>
                                              </div>
                                              {meetingStepper === MEETING_STEPPER.ADVISOR && (
                                                <div className="text-left p-6 pt-0">
                                                  <h2 className="text-lg font-semibold text-[#121212]">
                                                    Request Reschedule
                                                  </h2>
                                                  {/* Subheading */}
                                                  <p className="text-sm text-[#5E5E5E] mb-0">
                                                    {`Suggest a new time for "${rescheduleAppointId?.title}" `}
                                                  </p>
                                                </div>
                                              )}
                                              <hr className="border-[#ECECEC]" />

                                              {/* Email Input */}
                                              <div
                                                className="text-left p-6"
                                                style={{
                                                  display:
                                                    meetingStepper === MEETING_STEPPER.ADVISOR
                                                      ? 'flex'
                                                      : 'none',
                                                }}
                                              >
                                                <h2 className="text-lg font-[700] text-[#3F3F46]">
                                                  {meetingStepper === MEETING_STEPPER.ADVISOR &&
                                                    'Schedule Meeting'}
                                                </h2>
                                              </div>
                                              <hr className="border-[#ECECEC]" />

                                              {/* Members List */}

                                              <ul className="space-y-4 pt-0 p-6 pb-6">
                                                <div className="text-left sticky">
                                                  {meetingStepper === MEETING_STEPPER.ADVISOR && (
                                                    <>
                                                      <div className="mt-4">
                                                        {!isUserBusinessOwner() ? (
                                                          <>
                                                            <label className="text-sm text-[#3F3F46] font-futura">
                                                              Client
                                                            </label>

                                                            <Select
                                                              styles={{
                                                                control: (base, props) =>
                                                                  ({
                                                                    ...base,
                                                                    border: 'none',
                                                                    backgroundColor: '#F4F4F5',
                                                                    borderRadius: 10,
                                                                    fontFamily: 'Futura Std',
                                                                    boxShadow: 'none',
                                                                    '&:hover': {
                                                                      border: 'none',
                                                                    },
                                                                  } as CSSObjectWithLabel),
                                                              }}
                                                              classNames={{
                                                                control: (state) =>
                                                                  'font-futura text-[16px] font-[700] text-[#18181B] rounded-lg border-0 focus:border-0 h-[48px] mt-1',
                                                              }}
                                                              onChange={handleSelect}
                                                              value={selectedClient}
                                                              placeholder="Search"
                                                              options={list
                                                                ?.filter(
                                                                  ({ status }) =>
                                                                    status === 'active'
                                                                )
                                                                .map((user) => ({
                                                                  ...user,
                                                                  fullName: `${user.firstName} ${user.lastName}`,
                                                                }))
                                                                .sort((a, b) =>
                                                                  a.fullName.localeCompare(
                                                                    b.fullName
                                                                  )
                                                                )
                                                                .map((user) => {
                                                                  return {
                                                                    label: `${user.fullName} ${
                                                                      user.businessName
                                                                        ? `(${user.businessName})`
                                                                        : ''
                                                                    }`,
                                                                    value: user,
                                                                  }
                                                                })}
                                                              components={
                                                                components
                                                                  ? {
                                                                      ...components,
                                                                      MultiValueRemove,
                                                                      DropdownIndicator,
                                                                      IndicatorSeparator: () =>
                                                                        null,
                                                                    }
                                                                  : {
                                                                      IndicatorSeparator: () =>
                                                                        null,
                                                                      MultiValueRemove,
                                                                      DropdownIndicator,
                                                                    }
                                                              }
                                                            />
                                                            <div className="pt-6">
                                                              {selectedClient && (
                                                                <>
                                                                  <MeetingDurationTitle className="text-sm text-[#3F3F46] font-futura">
                                                                    Select meeting duration
                                                                  </MeetingDurationTitle>
                                                                  <div className="flex flex-row gap-3 flex-wrap mt-4">
                                                                    {timeDurationAvailabilityOptions.map(
                                                                      (option) => (
                                                                        <Tile
                                                                          onChange={
                                                                            handleChangeAvailability
                                                                          }
                                                                          value={
                                                                            selectedDuration
                                                                              ? selectedDuration.toString()
                                                                              : ''
                                                                          }
                                                                          label={option.label}
                                                                          optionValue={option.value}
                                                                          className={
                                                                            'w-[127px] !h-[70px]'
                                                                          }
                                                                        />
                                                                      )
                                                                    )}
                                                                  </div>
                                                                </>
                                                              )}
                                                            </div>
                                                            <div>
                                                              {selectedClient &&
                                                                userAvailabilityStatus ===
                                                                  availabilityStatus.LOADING && (
                                                                  <div className="h-full flex flex-col items-center p-5">
                                                                    <GradientCircleNotchIcon
                                                                      width="30"
                                                                      height="30"
                                                                    />
                                                                  </div>
                                                                )}
                                                              {selectedClient &&
                                                                userAvailabilityStatus ===
                                                                  availabilityStatus.FAILED &&
                                                                flashParams.availabilityConnectionError && (
                                                                  <>
                                                                    <p className="mt-8">
                                                                      {availabilityErrorMessage}
                                                                    </p>
                                                                    <Button
                                                                      className="mt-8 w-full"
                                                                      variant="primary"
                                                                      label="Send a message"
                                                                      onClick={() => {
                                                                        redirectTo(
                                                                          `/${getRoleFromPath()}/${tenantId}/chat`
                                                                        )
                                                                      }}
                                                                    />
                                                                  </>
                                                                )}

                                                              {selectedClient &&
                                                                userAvailabilityStatus ===
                                                                  availabilityStatus.SUCCESS && (
                                                                  <Button
                                                                    label={MEETING_STEPPER.CALENDAR}
                                                                    onClick={() =>
                                                                      dispatch(
                                                                        updateMeetingStepperAction({
                                                                          actionType: 'increment',
                                                                          stepName:
                                                                            MEETING_STEPPER.CALENDAR,
                                                                        })
                                                                      )
                                                                    }
                                                                    disabled={
                                                                      userAvailabilityList
                                                                        ?.availability?.length === 0
                                                                    }
                                                                    className="w-full"
                                                                  />
                                                                )}
                                                            </div>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <label className="text-sm text-[#3F3F46] font-futura">
                                                              Advisor
                                                            </label>
                                                            <Select
                                                              styles={{
                                                                control: (base, props) =>
                                                                  ({
                                                                    ...base,
                                                                    border: 'none',
                                                                    backgroundColor: '#F4F4F5',
                                                                    borderRadius: 10,
                                                                    fontFamily: 'Futura Std',
                                                                    boxShadow: 'none',
                                                                    '&:hover': {
                                                                      border: 'none',
                                                                    },
                                                                  } as CSSObjectWithLabel),
                                                              }}
                                                              classNames={{
                                                                control: (state) =>
                                                                  'font-futura text-[16px] font-[700] text-[#18181B] rounded-lg border-0 focus:border-0 h-[48px] mt-1',
                                                              }}
                                                              onChange={handleSelectAdvisor}
                                                              value={selectedAdvisor}
                                                              placeholder="Search"
                                                              options={boAdvisors
                                                                ?.sort((a, b) =>
                                                                  a.lastName.localeCompare(
                                                                    b.lastName
                                                                  )
                                                                )
                                                                .map((user) => {
                                                                  return {
                                                                    label: `${user.firstName} ${user.lastName}`,
                                                                    value: user,
                                                                  }
                                                                })}
                                                              components={
                                                                components
                                                                  ? {
                                                                      ...components,
                                                                      MultiValueRemove,
                                                                      DropdownIndicator,
                                                                      IndicatorSeparator: () =>
                                                                        null,
                                                                    }
                                                                  : {
                                                                      IndicatorSeparator: () =>
                                                                        null,
                                                                      MultiValueRemove,
                                                                      DropdownIndicator,
                                                                    }
                                                              }
                                                            />
                                                            <MeetingDuration>
                                                              {isAvailabilityHoursLoading && (
                                                                <div className="h-full flex flex-col items-center">
                                                                  <GradientCircleNotchIcon
                                                                    width="80"
                                                                    height="80"
                                                                  />
                                                                </div>
                                                              )}
                                                              {selectedAdvisor &&
                                                                !isAvailabilityHoursLoading && (
                                                                  <Fragment>
                                                                    <MeetingDurationTitle className="font-futura">
                                                                      Select meeting duration
                                                                    </MeetingDurationTitle>
                                                                    <div className="flex flex-row gap-3 flex-wrap">
                                                                      {durationOptions.map(
                                                                        (option) => (
                                                                          <Tile
                                                                            onChange={
                                                                              handleChangeAvailabilityAdvisor
                                                                            }
                                                                            value={
                                                                              selectedDuration
                                                                                ? selectedDuration.toString()
                                                                                : ''
                                                                            }
                                                                            label={option.label}
                                                                            optionValue={
                                                                              option.value
                                                                            }
                                                                            className={
                                                                              'w-[127px] !h-[70px]'
                                                                            }
                                                                          />
                                                                        )
                                                                      )}
                                                                    </div>
                                                                  </Fragment>
                                                                )}
                                                              {selectedAdvisor &&
                                                                userAvailabilityStatus ===
                                                                  availabilityStatus.SUCCESS &&
                                                                !isAvailabilityHoursLoading &&
                                                                !isEmpty(
                                                                  userAvailabilityList?.availability
                                                                ) && (
                                                                  <Button
                                                                    label="Select a Date"
                                                                    onClick={() =>
                                                                      dispatch(
                                                                        updateMeetingStepperAction({
                                                                          actionType: 'increment',
                                                                          stepName:
                                                                            MEETING_STEPPER.CALENDAR,
                                                                        })
                                                                      )
                                                                    }
                                                                    disabled={isEmpty(
                                                                      userAvailabilityList?.availability
                                                                    )}
                                                                    className="w-full"
                                                                  />
                                                                )}
                                                              {selectedDuration !== null &&
                                                                selectedDuration !== undefined &&
                                                                selectedDuration.toString() &&
                                                                userAvailabilityStatus ===
                                                                  availabilityStatus.LOADING && (
                                                                  <div className="h-full flex flex-col items-center p-5">
                                                                    <GradientCircleNotchIcon
                                                                      width="30"
                                                                      height="30"
                                                                    />
                                                                  </div>
                                                                )}
                                                              {isError && (
                                                                <Fragment>
                                                                  <p>
                                                                    {
                                                                      availabilityErrorMessageAdvisor
                                                                    }
                                                                  </p>
                                                                  <Button
                                                                    className="mt-8 w-full"
                                                                    variant="primary"
                                                                    label="Send a message"
                                                                    onClick={() => {
                                                                      redirectTo(
                                                                        `/owner/${tenantId}/chat`
                                                                      )
                                                                    }}
                                                                  />
                                                                </Fragment>
                                                              )}
                                                            </MeetingDuration>
                                                          </>
                                                        )}
                                                      </div>
                                                    </>
                                                  )}

                                                  {/* CALENDAR */}
                                                  <div>
                                                    {meetingStepper ===
                                                      MEETING_STEPPER.CALENDAR && (
                                                      <div className="h-[500px] overflow-auto mt-6">
                                                        <div>
                                                          <div className="text-[#3F3F46] text-md font-[500] font-futura">
                                                            {participantLabel}
                                                          </div>
                                                          <div className="text-[#18181B] text-md font-[700] border-b border-[#ECECEC] py-4 font-futura">
                                                            {participantName?.value?.firstName}{' '}
                                                            {participantName?.value?.lastName}
                                                          </div>
                                                        </div>
                                                        <div className="text-[#18181B] text-md font-[700] border-b border-[#ECECEC] py-4 font-futura">
                                                          {selectedDuration} min meeting
                                                        </div>

                                                        {!isBusinessOwner && (
                                                          <CheckboxWrapper>
                                                            <Controller
                                                              name="ignoreConflicts"
                                                              control={control}
                                                              render={({ field }) => (
                                                                <CheckBoxField
                                                                  {...field}
                                                                  id=""
                                                                  className="!gap-2 !pr-0"
                                                                  onChange={(value) => {
                                                                    field.onChange(value)
                                                                    handleChangeConflicts(value)
                                                                  }}
                                                                />
                                                              )}
                                                            />
                                                            <span className="text font-futura">
                                                              {userRole === ROLES.BUSINESS_OWNER
                                                                ? 'Ignore scheduling conflicts with my calendar'
                                                                : 'Ignore scheduling conflicts'}{' '}
                                                            </span>
                                                          </CheckboxWrapper>
                                                        )}
                                                        <CalendarTitle>Select Date:</CalendarTitle>
                                                        <div>
                                                          {userAvailabilityStatus ===
                                                          availabilityStatus.LOADING ? (
                                                            <div className="flex justify-center">
                                                              <GradientCircleNotchIcon
                                                                width="100"
                                                                height="100"
                                                              />
                                                            </div>
                                                          ) : (
                                                            <CalendarWrapper>
                                                              <Calendar
                                                                view="month"
                                                                showFixedNumberOfWeeks={true}
                                                                formatDay={(_, date) =>
                                                                  moment(date).local().format('DD')
                                                                }
                                                                formatShortWeekday={(_, date) =>
                                                                  moment(date).local().format('ddd')
                                                                }
                                                                className="!w-full "
                                                                onChange={handleCalendarChange}
                                                                value={calendarDate}
                                                                tileClassName={(props) =>
                                                                  getTileClassName({
                                                                    ...props,
                                                                    userAvailabilityList,
                                                                  })
                                                                }
                                                                onClickDay={handleTileClick}
                                                                locale="en-US"
                                                                onActiveStartDateChange={
                                                                  refreshAdvisorAvailability
                                                                }
                                                              />
                                                            </CalendarWrapper>
                                                          )}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                  {/* SLOTS */}
                                                  {meetingStepper === MEETING_STEPPER.SLOTS &&
                                                    userAvailabilityStatus === 'loading' && (
                                                      <div className="col-span-12 flex flex-row justify-center p-12">
                                                        <CircleNotchIcon
                                                          className={'fill-primary'}
                                                          width="63"
                                                          height="66"
                                                        />
                                                      </div>
                                                    )}
                                                  {meetingStepper === MEETING_STEPPER.SLOTS &&
                                                    isEmpty(availableSlots) &&
                                                    userAvailabilityStatus !== 'loading' && (
                                                      <NoSlotLabel>
                                                        Sorry, No Slots Available on this Day
                                                      </NoSlotLabel>
                                                    )}

                                                  {meetingStepper === MEETING_STEPPER.SLOTS &&
                                                    !isEmpty(availableSlots) && (
                                                      <div className="pt-6">
                                                        <div className="text-[#18181B] text-[20px] font-[500] font-futura">
                                                          {formattedDate}
                                                        </div>
                                                        <TimeDuration>
                                                          <div className="mt-4">
                                                            <p className="font-[500] text-md text-[#3F3F46] mb-4 font-futura">
                                                              Time Zone:
                                                            </p>{' '}
                                                            <p className="text-[#5E06B9] text-md font-[700]">
                                                              {getTimeZoneDisplayRepresentation(
                                                                user?.timezone ?? moment.tz.guess()
                                                              )}{' '}
                                                              ({currentTime})
                                                            </p>
                                                          </div>
                                                        </TimeDuration>
                                                        <TimeDuration>
                                                          <div className="font-[500] text-md text-[#3F3F46] border-b border-[#ECECEC] pb-4">
                                                            Meeting Duration:{' '}
                                                            {`${userAvailabilityList?.duration} minutes`}{' '}
                                                          </div>
                                                        </TimeDuration>

                                                        {/* <Divider /> */}
                                                        <div className="mt-0 mb-3 font-futura">
                                                          Select a time:
                                                        </div>
                                                        <div className="h-[300px] overflow-auto">
                                                          {isBusinessOwner ? (
                                                            <div className="h-[300px] overflow-hidden">
                                                              <SlotsSelector
                                                                availableSlots={availableSlots}
                                                                onClick={(slot) => {
                                                                  setSelectedSlot(slot)
                                                                  dispatch(
                                                                    updateMeetingStepperAction({
                                                                      actionType: 'increment',
                                                                      stepName:
                                                                        MEETING_STEPPER.DESCRIPTION,
                                                                    })
                                                                  )
                                                                }}
                                                              />
                                                            </div>
                                                          ) : (
                                                            <PaginatedSlots
                                                              slots={availableSlots}
                                                              date={selectedDate}
                                                              onClick={(event) => {
                                                                setSelectedSlot(event)
                                                                dispatch(
                                                                  updateMeetingStepperAction({
                                                                    actionType: 'increment',
                                                                    stepName:
                                                                      MEETING_STEPPER.DESCRIPTION,
                                                                  })
                                                                )
                                                              }}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                    )}

                                                  {meetingStepper ===
                                                    MEETING_STEPPER.DESCRIPTION && (
                                                    <div className="pt-4">
                                                      <IconWithLabel>
                                                        <CalendarIcon
                                                          className={
                                                            'inline mr-3 fill-primary-text'
                                                          }
                                                        />
                                                        <span className="font-[400] text-[18px] text-[#18181B] font-futura">
                                                          {formattedDate}
                                                        </span>
                                                      </IconWithLabel>
                                                      <div className=" border-b border-[#ECECEC] mt-4 pb-4">
                                                        {selectedSlot && (
                                                          <IconWithLabel>
                                                            <ClockIcon
                                                              className={
                                                                'inline mr-3 fill-primary-disabled hover:!fill-primary-disabled'
                                                              }
                                                            />
                                                            <div className="flex flex-col">
                                                              <span className="text-[18px] font-normal text-[#18181B] font-futura">
                                                                {selectedSlot.slotStartTime} -{' '}
                                                                {selectedSlot.slotEndTime}
                                                              </span>
                                                              <p className="text-[18px] font-normal text-[#18181B] font-futura">
                                                                ({user.timezone})
                                                              </p>
                                                            </div>
                                                          </IconWithLabel>
                                                        )}
                                                      </div>
                                                      {/* <Divider /> */}
                                                      <div className="h-[400px] overflow-auto font-futura">
                                                        <InputFieldsWrapper>
                                                          <MeetingDetails
                                                            event={rescheduleAppointId}
                                                            selectedUser={participantName?.value!}
                                                            isEdit={false}
                                                            onSubmit={onSubmit}
                                                            isDisabled={isRescheduleMeetingLoading}
                                                            description={meetingDescription}
                                                            setDescription={setMeetingDescription}
                                                            updateMeetingStepperAction={
                                                              updateMeetingStepperAction
                                                            }
                                                            videoLinkDescription={
                                                              advisorProfile?.defaultVideoLinkDescription ??
                                                              user?.defaultVideoLinkDescription ??
                                                              ''
                                                            }
                                                            user={user}
                                                            userAvailableMeetingLocation={
                                                              userAvailableMeetingLocation
                                                            }
                                                            methods={methods}
                                                          />
                                                        </InputFieldsWrapper>
                                                      </div>
                                                    </div>
                                                  )}
                                                  {meetingStepper ===
                                                    MEETING_STEPPER.MEETING_CONFIRMATION &&
                                                    selectedAdvisor && (
                                                      <MeetingConfirmationContainer
                                                        labelText=""
                                                        handleClose={handleClose}
                                                        errorMessage={error}
                                                        successMessage={successMessage}
                                                      />
                                                    )}
                                                </div>
                                              </ul>
                                            </div>
                                          </div>
                                        )}

                                      {requestId && requestId.id === upcoming.id && (
                                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                                          <div className="bg-white w-full max-w-lg mx-auto rounded-[16px] shadow-lg">
                                            {/* Header */}
                                            <div className="flex justify-between items-center  p-6 pb-4 relative min-h-[69px]">
                                              {meetingStepper !== MEETING_STEPPER.ADVISOR && (
                                                <div className="flex items-center gap-2">
                                                  <img
                                                    src={require('../../../../appAssets/appImages/chevron-left.png')}
                                                    alt="arrow"
                                                    width={20}
                                                    onClick={() => {
                                                      dispatch(
                                                        updateMeetingStepperAction({
                                                          actionType: 'decrement',
                                                        })
                                                      )
                                                    }}
                                                  />
                                                  <h2 className="text-lg font-semibold text-[#3F3F46]">
                                                    {meetingStepper === MEETING_STEPPER.ADVISOR
                                                      ? 'Schedule Meeting'
                                                      : meetingStepper === MEETING_STEPPER.CALENDAR
                                                      ? 'Select a Date'
                                                      : meetingStepper === MEETING_STEPPER.SLOTS
                                                      ? 'Select a Time'
                                                      : 'Confirm Meeting'}
                                                  </h2>
                                                </div>
                                              )}
                                              <button
                                                onClick={() => {
                                                  dispatch(
                                                    updateMeetingStepperAction({
                                                      actionType: 'reset',
                                                      stepName: MEETING_STEPPER.ADVISOR,
                                                    })
                                                  )
                                                  setMeetingDescription(EditorState.createEmpty())
                                                  setRequestId(null)
                                                }}
                                                className="text-gray-500 hover:text-gray-700 absolute right-[20px]"
                                              >
                                                <img
                                                  src={require('../../../../appAssets/appImages/x-mark.png')}
                                                  alt="close"
                                                  width={20}
                                                />
                                              </button>
                                            </div>
                                            {meetingStepper === MEETING_STEPPER.ADVISOR && (
                                              <div className="text-left p-6 pt-0">
                                                <h2 className="text-lg font-semibold text-[#121212]">
                                                  Request Reschedule
                                                </h2>
                                                {/* Subheading */}
                                                <p className="text-sm text-[#5E5E5E] mb-0">
                                                  {`Suggest a new time for "${rescheduleAppointId?.title}" `}
                                                </p>
                                              </div>
                                            )}
                                            <hr className="border-[#ECECEC]" />

                                            {/* Members List */}

                                            <ul className="space-y-4  p-6 pb-6">
                                              <div className="text-left sticky">
                                                {/* CALENDAR */}
                                                {meetingStepper === MEETING_STEPPER.CALENDAR && (
                                                  <div>
                                                    <div className="h-[500px] overflow-auto mt-6">
                                                      <div>
                                                        <div className="text-[#3F3F46] text-md font-[500] font-futura">
                                                          {participantLabel}
                                                        </div>
                                                        <div className="text-[#18181B] text-md font-[700] border-b border-[#ECECEC] py-4 font-futura">
                                                          {isBusinessOwner
                                                            ? requestId?.organizerDetail.firstName
                                                            : requestId?.participantDetail
                                                                .firstName}{' '}
                                                          {isBusinessOwner
                                                            ? requestId?.organizerDetail.lastName
                                                            : requestId?.participantDetail.lastName}
                                                        </div>
                                                      </div>
                                                      <div className="text-[#18181B] text-md font-[700] border-b border-[#ECECEC] py-4 font-futura">
                                                        {durationMinutes} min meeting
                                                      </div>

                                                      {!isBusinessOwner && (
                                                        <CheckboxWrapper>
                                                          <Controller
                                                            name="ignoreConflicts"
                                                            control={control}
                                                            render={({ field }) => (
                                                              <CheckBoxField
                                                                {...field}
                                                                id=""
                                                                className="!gap-2 !pr-0"
                                                                onChange={(value) => {
                                                                  field.onChange(value)
                                                                  handleChangeConflicts(value)
                                                                }}
                                                              />
                                                            )}
                                                          />
                                                          <span className="text font-futura">
                                                            {userRole === ROLES.BUSINESS_OWNER
                                                              ? 'Ignore scheduling conflicts with my calendar'
                                                              : 'Ignore scheduling conflicts'}{' '}
                                                          </span>
                                                        </CheckboxWrapper>
                                                      )}
                                                      <CalendarTitle>Select Date:</CalendarTitle>
                                                      {userAvailabilityStatus ===
                                                      availabilityStatus.LOADING ? (
                                                        <div className="flex justify-center">
                                                          <GradientCircleNotchIcon
                                                            width="100"
                                                            height="100"
                                                          />
                                                        </div>
                                                      ) : (
                                                        <CalendarWrapper>
                                                          <Calendar
                                                            view="month"
                                                            showFixedNumberOfWeeks={true}
                                                            formatDay={(_, date) =>
                                                              moment(date).local().format('DD')
                                                            }
                                                            formatShortWeekday={(_, date) =>
                                                              moment(date).local().format('ddd')
                                                            }
                                                            className="!w-full "
                                                            onChange={handleCalendarChange}
                                                            value={calendarDate}
                                                            tileClassName={(props) =>
                                                              getTileClassName({
                                                                ...props,
                                                                userAvailabilityList,
                                                              })
                                                            }
                                                            onClickDay={handleTileClick}
                                                            locale="en-US"
                                                            onActiveStartDateChange={
                                                              refreshRequestAvailability
                                                            }
                                                          />
                                                        </CalendarWrapper>
                                                      )}
                                                    </div>
                                                  </div>
                                                )}

                                                {/* SLOTS */}
                                                {meetingStepper === MEETING_STEPPER.SLOTS &&
                                                  userAvailabilityStatus === 'loading' && (
                                                    <div className="col-span-12 flex flex-row justify-center p-12">
                                                      <CircleNotchIcon
                                                        className={'fill-primary'}
                                                        width="63"
                                                        height="66"
                                                      />
                                                    </div>
                                                  )}
                                                {meetingStepper === MEETING_STEPPER.SLOTS &&
                                                  isEmpty(availableSlots) &&
                                                  userAvailabilityStatus !== 'loading' && (
                                                    <NoSlotLabel>
                                                      Sorry, No Slots Available on this Day
                                                    </NoSlotLabel>
                                                  )}

                                                {meetingStepper === MEETING_STEPPER.SLOTS &&
                                                  !isEmpty(availableSlots) && (
                                                    <div className="pt-6">
                                                      <div className="text-[#18181B] text-[20px] font-[500] font-futura">
                                                        {formattedDate}
                                                      </div>
                                                      <TimeDuration>
                                                        <div className="mt-4">
                                                          <p className="font-[500] text-md text-[#3F3F46] mb-4 font-futura">
                                                            Time Zone:
                                                          </p>{' '}
                                                          <p className="text-[#5E06B9] text-md font-[700]">
                                                            {getTimeZoneDisplayRepresentation(
                                                              user?.timezone ?? moment.tz.guess()
                                                            )}{' '}
                                                            ({currentTime})
                                                          </p>
                                                        </div>
                                                      </TimeDuration>
                                                      <TimeDuration>
                                                        <div className="font-[500] text-md text-[#3F3F46] border-b border-[#ECECEC] pb-4">
                                                          Meeting Duration:{' '}
                                                          {`${userAvailabilityList?.duration} minutes`}{' '}
                                                        </div>
                                                      </TimeDuration>

                                                      {/* <Divider /> */}
                                                      <div className="mt-0 mb-3 font-futura">
                                                        Select a time:
                                                      </div>

                                                      <div className="h-[300px] overflow-auto">
                                                        {isBusinessOwner ? (
                                                          <div className="h-[300px] overflow-hidden">
                                                            <SlotsSelector
                                                              availableSlots={availableSlots}
                                                              onClick={(slot) => {
                                                                setSelectedSlot(slot)

                                                                dispatch(
                                                                  updateMeetingStepperAction({
                                                                    actionType: 'increment',
                                                                    stepName:
                                                                      MEETING_STEPPER.DESCRIPTION,
                                                                  })
                                                                )
                                                              }}
                                                            />
                                                          </div>
                                                        ) : (
                                                          <PaginatedSlots
                                                            slots={availableSlots}
                                                            date={selectedDate}
                                                            onClick={(event) => {
                                                              setSelectedSlot(event)
                                                              dispatch(
                                                                updateMeetingStepperAction({
                                                                  actionType: 'increment',
                                                                  stepName:
                                                                    MEETING_STEPPER.DESCRIPTION,
                                                                })
                                                              )
                                                            }}
                                                          />
                                                        )}
                                                      </div>
                                                    </div>
                                                  )}

                                                {meetingStepper === MEETING_STEPPER.DESCRIPTION && (
                                                  <div>
                                                    <IconWithLabel>
                                                      <CalendarIcon
                                                        className={'inline mr-3 fill-primary-text'}
                                                      />
                                                      <span className="font-[400] text-[18px] text-[#18181B] font-futura">
                                                        {formattedDate}
                                                      </span>
                                                    </IconWithLabel>
                                                    <div className=" border-b border-[#ECECEC] pb-4">
                                                      {selectedSlot && (
                                                        <IconWithLabel>
                                                          <ClockIcon
                                                            className={
                                                              'inline mr-3 fill-primary-disabled hover:!fill-primary-disabled'
                                                            }
                                                          />
                                                          <div className="flex flex-col">
                                                            <span className="text-[18px] font-normal text-[#18181B] font-futura">
                                                              {selectedSlot.slotStartTime} -{' '}
                                                              {selectedSlot.slotEndTime}
                                                            </span>
                                                            <p className="text-[18px] font-normal text-[#18181B] font-futura">
                                                              ({user.timezone})
                                                            </p>
                                                          </div>
                                                        </IconWithLabel>
                                                      )}
                                                    </div>
                                                    {/* <Divider /> */}
                                                    <div className="h-[400px] overflow-auto">
                                                      <InputFieldsWrapper>
                                                        <MeetingDetails
                                                          event={requestId}
                                                          selectedUser={
                                                            participantName?.value! ||
                                                            isBusinessOwner
                                                              ? requestId?.organizerDetail
                                                              : requestId?.participantDetail
                                                          }
                                                          isEdit={false}
                                                          onSubmit={onSubmit}
                                                          isDisabled={isRequestMeetingLoading}
                                                          description={meetingDescription}
                                                          setDescription={setMeetingDescription}
                                                          updateMeetingStepperAction={
                                                            updateMeetingStepperAction
                                                          }
                                                          videoLinkDescription={
                                                            advisorProfile?.defaultVideoLinkDescription ??
                                                            user?.defaultVideoLinkDescription ??
                                                            ''
                                                          }
                                                          user={user}
                                                          userAvailableMeetingLocation={
                                                            userAvailableMeetingLocation
                                                          }
                                                          methods={methods}
                                                        />
                                                      </InputFieldsWrapper>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </ul>
                                          </div>
                                        </div>
                                      )}

                                      {showSucess && (
                                        <AppInvitationSuccessModal
                                          onClose={() => {
                                            setShowSuccess(false)
                                            setInvitedEmails([])
                                            setInviteMeetingData([])
                                            setAttendee([])
                                          }}
                                          meetingTitle={inviteMeetingData?.title}
                                          date={moment(inviteMeetingData?.end)
                                            .tz(inviteMeetingData?.timezone)
                                            .format('MMM DD, YYYY')}
                                          time={inviteMeetingData?.time}
                                          timezone={moment()
                                            .tz(inviteMeetingData?.timezone)
                                            .format('z')}
                                          participants={invitedEmails}
                                          invitedEmails={invitedEmails}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {selectedMeeting && showModal && (
                          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
                            <div className="bg-white w-[400px] max-w-md mx-auto p-6 rounded-[16px] shadow-lg">
                              <div className="relative mb-2 text-center">
                                <div className="w-full text-center inline-block">
                                  <img
                                    alt=""
                                    className="w-[48px] inline-block"
                                    src={require('../../../../appAssets/appImages/Icon.png')}
                                  />
                                </div>
                                <h5 className="text-md font-medium pt-3 mt-3 text-xl">
                                  Cancel Appointment
                                </h5>
                                <button
                                  onClick={() => setShowModal(false)}
                                  className="text-gray-600 hover:text-gray-900 absolute right-2 top-2"
                                >
                                  <img
                                    src={require('../../../../appAssets/appImages/x-mark.png')}
                                    alt="close"
                                    width={20}
                                  />
                                </button>
                              </div>
                              <p className="text-sm text-[#5E5E5E] mb-4 text-center">
                                Are you sure you want to cancel the appointment?
                              </p>
                              <p className="text-sm text-[#5E5E5E] mb-4 pb-4 text-center">
                                Please confirm your decision or let them know if you’d like to
                                reschedule.
                              </p>
                              <div className="mb-4 mt-4 shadow rounded-lg border border-[#ECECEC] p-3">
                                <h6 className="font-normal flex items-center gap-2 text-md text-[#5E5E5E] mb-2">
                                  {selectedMeeting?.title || 'NA'}
                                </h6>
                                <p className="text-sm text-[#121212] pt-1 pb-2">
                                  {moment(selectedMeeting?.start).format('MMMM D, YYYY | h:mm A')} -{' '}
                                  {moment(selectedMeeting?.end).format('h:mm A z')}
                                </p>

                                <div className="flex mt-2">
                                  <span
                                    className={` ${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: selectedMeeting?.organizerDetail?.firstName,
                                          lastName: selectedMeeting?.organizerDetail?.lastName,
                                        })
                                      ]?.bg
                                    } ${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: selectedMeeting?.organizerDetail?.firstName,
                                          lastName: selectedMeeting?.organizerDetail?.lastName,
                                        })
                                      ]?.text
                                    }  w-8 h-8 text-[14px] ml-[-5px] rounded-full text-center items-center justify-center flex capitalize  border border-[#fff]`}
                                  >
                                    {getInitialsWithDots({
                                      firstName: selectedMeeting?.organizerDetail?.firstName,
                                      lastName: selectedMeeting?.organizerDetail?.lastName,
                                      email: '',
                                    })}
                                  </span>
                                  <span
                                    className={` ${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: selectedMeeting?.participantDetail?.firstName,
                                          lastName: selectedMeeting?.participantDetail?.lastName,
                                        })
                                      ]?.bg
                                    } ${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: selectedMeeting?.participantDetail?.firstName,
                                          lastName: selectedMeeting?.participantDetail?.lastName,
                                        })
                                      ]?.text
                                    }   w-8 h-8 text-[14px] ml-[-5px] rounded-full  text-center items-center justify-center flex capitalize  border border-[#fff]`}
                                  >
                                    {getInitialsWithDots({
                                      firstName: selectedMeeting?.participantDetail?.firstName,
                                      lastName: selectedMeeting?.participantDetail?.lastName,
                                      email: '',
                                    })}
                                  </span>
                                  {selectedMeeting?.attendeesEmail?.map((email) => (
                                    <span
                                      key={email}
                                      className={`${
                                        colorClasses[
                                          getColorIndex({
                                            email: email,
                                            firstName: '',
                                            lastName: '',
                                          })
                                        ]?.bg
                                      } ${
                                        colorClasses[
                                          getColorIndex({
                                            email: email,
                                            firstName: '',
                                            lastName: '',
                                          })
                                        ]?.text
                                      } w-8 h-8 text-[14px] ml-[-5px] rounded-full  text-center items-center justify-center flex capitalize  border border-[#fff]`}
                                    >
                                      {getInitialsWithDots({
                                        firstName: '',
                                        lastName: '',
                                        email: email,
                                      })}
                                    </span>
                                  ))}
                                </div>
                                <div className="flex gap-1 mt-2"></div>
                              </div>
                              <div className="gap-2 pt-4">
                                <button
                                  onClick={() => {
                                    const start = selectedMeeting?.start
                                      ? new Date(selectedMeeting.start)
                                      : null
                                    const end = selectedMeeting?.end
                                      ? new Date(selectedMeeting.end)
                                      : null

                                    const isValidDate = (date: any) =>
                                      date instanceof Date && !isNaN(date.getTime())

                                    const durationMs =
                                      isValidDate(start) && isValidDate(end) && end && start
                                        ? end.getTime() - start.getTime()
                                        : 0

                                    const durationMinute =
                                      durationMs > 0 ? durationMs / (1000 * 60) : 0

                                    setSelectedDuration(durationMinute)
                                    setRescheduleAppointId(selectedMeeting)

                                    setShowModal(false)
                                  }}
                                  className="px-4 py-2 text-white rounded-lg w-full border border-grey-lighter4x mb-1 bg-purple"
                                >
                                  Reschedule Meeting
                                </button>
                                <button
                                  onClick={() =>
                                    onMeetingDelete(
                                      selectedMeeting?.eventId,
                                      selectedMeeting?.eventType,
                                      selectedMeeting?.id
                                    )
                                  }
                                  className="px-4 py-2  text-black rounded-lg w-full border border-grey-lighter4x"
                                >
                                  Cancel Meeting
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                        {confirmMeetingModal && (
                          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
                            <div className="bg-white w-[400px] max-w-md mx-auto p-6 rounded-[16px] shadow-lg">
                              <div className="relative mb-2 text-center">
                                <div className="w-full text-center inline-block mb-4">
                                  <img
                                    alt=""
                                    className="w-[48px] inline-block"
                                    src={require('../../../../appAssets/appImages/Icon.png')}
                                  />
                                </div>
                                <h5 className="text-md font-medium pt-3 text-xl mb-2">
                                  Cancel Appointment
                                </h5>
                              </div>
                              <p className="text-sm text-[#5E5E5E] mb-4 pb-4 text-center">
                                {` Your meeting with ${participant.firstName} ${participant.lastName} has been canceled.`}
                              </p>

                              <div className="mb-4 mt-4 shadow rounded-lg border border-[#ECECEC] p-3">
                                <h6 className="font-normal flex items-center gap-2 text-sm text-[#5E5E5E]">
                                  {selectedMeeting?.title || 'NA'}
                                </h6>
                                <p className="text-sm text-[#121212] pt-1">
                                  {moment(selectedMeeting?.start).format('MMMM D, YYYY | h:mm A')} -{' '}
                                  {moment(selectedMeeting?.end).format('h:mm A z')}
                                </p>
                                <div className="flex mt-2">
                                  <span
                                    className={` ${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: selectedMeeting?.organizerDetail?.firstName,
                                          lastName: selectedMeeting?.organizerDetail?.lastName,
                                        })
                                      ]?.bg
                                    } ${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: selectedMeeting?.organizerDetail?.firstName,
                                          lastName: selectedMeeting?.organizerDetail?.lastName,
                                        })
                                      ]?.text
                                    }  w-8 h-8 text-[14px] ml-[-5px] rounded-full  text-center items-center justify-center flex capitalize  border border-[#fff]`}
                                  >
                                    {getInitialsWithDots({
                                      firstName: selectedMeeting?.organizerDetail?.firstName,
                                      lastName: selectedMeeting?.organizerDetail?.lastName,
                                      email: '',
                                    })}
                                  </span>
                                  <span
                                    className={` ${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: selectedMeeting?.participantDetail?.firstName,
                                          lastName: selectedMeeting?.participantDetail?.lastName,
                                        })
                                      ]?.bg
                                    } ${
                                      colorClasses[
                                        getColorIndex({
                                          email: '',
                                          firstName: selectedMeeting?.participantDetail?.firstName,
                                          lastName: selectedMeeting?.participantDetail?.lastName,
                                        })
                                      ]?.text
                                    }   w-8 h-8 text-[14px] ml-[-5px] rounded-full  text-center items-center justify-center flex capitalize  border border-[#fff]`}
                                  >
                                    {getInitialsWithDots({
                                      firstName: selectedMeeting?.participantDetail?.firstName,
                                      lastName: selectedMeeting?.participantDetail?.lastName,
                                      email: '',
                                    })}
                                  </span>
                                  {selectedMeeting?.attendeesEmail?.map((email) => (
                                    <span
                                      key={email}
                                      className={`${
                                        colorClasses[
                                          getColorIndex({
                                            email: email,
                                            firstName: '',
                                            lastName: '',
                                          })
                                        ]?.bg
                                      } ${
                                        colorClasses[
                                          getColorIndex({
                                            email: email,
                                            firstName: '',
                                            lastName: '',
                                          })
                                        ]?.text
                                      } w-8 h-8 text-[14px] ml-[-5px] rounded-full  text-center items-center justify-center flex capitalize  border border-[#fff]`}
                                    >
                                      {getInitialsWithDots({
                                        firstName: '',
                                        lastName: '',
                                        email: email,
                                      })}
                                    </span>
                                  ))}
                                </div>
                              </div>
                              <p className="text-sm text-[#5E5E5E] mb-4 pt-4 pb-4 text-center">
                                We’ve notified them about the cancellation.
                              </p>
                              <div className="gap-2">
                                <button
                                  onClick={handleConfirmationCloseModal}
                                  className="px-4 py-2 text-white rounded-lg w-full border border-grey-lighter4x mb-1 bg-purple"
                                >
                                  OK
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </section>
                    </>
                  )
                })
              })()}
            </>
          )}

          {filter.includes('previous') && (
            <>
              {meetingDataLoading && (
                <div className="mt-4 space-y-2">
                  <div className="flex justify-center items-center gap-2">
                    <GradientCircleNotchIcon width="100" height="100" />
                  </div>
                </div>
              )}
              {(() => {
                let lastMonth = ''
                return previousMeetingList.map((previous) => {
                  const meetingDate = moment.tz(previous.start, user.timezone).toDate()

                  const day = meetingDate.getDate()
                  const week = meetingDate.toLocaleString('default', { weekday: 'long' })
                  const month = meetingDate.toLocaleString('default', { month: 'long' })
                  const showMonth = month !== lastMonth
                  lastMonth = month
                  const time = previous.time

                  return (
                    <>
                      <section className="pb-6 font-sans bg-gray-50 text-gray-800 px-5 md:px-0">
                        <div className="mx-auto">
                          <div className="space-y-8">
                            <div>
                              {showMonth && <h6 className="text-lg font-medium mb-4">{month}</h6>}
                              <div className="flex flex-col gap-6">
                                <div
                                  className={
                                    showDropdown
                                      ? 'flex flex-col md:flex-row justify-between items-start p-4 pl-2 rounded-lg border border-grey-lighter4x items-center border-purple'
                                      : 'flex flex-col md:flex-row justify-between items-start p-4 pl-2 bg-white rounded-lg border border-[#ECECEC] items-center'
                                  }
                                >
                                  <div className="flex gap-4 ">
                                    <div className="text-center w-24 border-e border-[#ECECEC]">
                                      <p className="text-[16px] text-[#71717A] leading-[40px]">
                                        {week.substring(0, 3)}
                                      </p>
                                      <span className="text-[40px] font-medium text-[#71717A] leading-[40px]">
                                        {day}
                                      </span>
                                    </div>
                                    <div className="ps-6">
                                      <h6 className="font-medium flex items-center gap-2 text-md mb-2">
                                        {previous?.title || 'NA'}
                                      </h6>
                                      <p className="text-sm text-[#5E5E5E]">
                                        {time} {moment().tz(previous?.timezone).format('z')}
                                      </p>
                                      <div className="flex mt-2">
                                        <span
                                          className={` ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: previous?.organizerDetail?.firstName,
                                                lastName: previous?.organizerDetail?.lastName,
                                              })
                                            ]?.bg
                                          } ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: previous?.organizerDetail?.firstName,
                                                lastName: previous?.organizerDetail?.lastName,
                                              })
                                            ]?.text
                                          }  w-8 h-8 text-[14px] rounded-full  text-center items-center justify-center flex capitalize ml-[-5px]  border border-[#fff] [&:nth-child(1)]:-ml-[0px]`}
                                        >
                                          {getInitialsWithDots({
                                            firstName: previous?.organizerDetail?.firstName,
                                            lastName: previous?.organizerDetail?.lastName,
                                            email: '',
                                          })}
                                        </span>
                                        <span
                                          className={` ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: previous?.participantDetail?.firstName,
                                                lastName: previous?.participantDetail?.lastName,
                                              })
                                            ]?.bg
                                          } ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: previous?.participantDetail?.firstName,
                                                lastName: previous?.participantDetail?.lastName,
                                              })
                                            ]?.text
                                          }  w-8 h-8 text-[14px] rounded-full  text-center items-center justify-center flex capitalize ml-[-5px]  border border-[#fff] [&:nth-child(1)]:-ml-[0px]`}
                                        >
                                          {getInitialsWithDots({
                                            firstName: previous?.participantDetail?.firstName,
                                            lastName: previous?.participantDetail?.lastName,
                                            email: '',
                                          })}
                                        </span>
                                        {[...new Set(previous?.attendeesEmail)].map((email) => (
                                          <span
                                            className={`${
                                              colorClasses[
                                                getColorIndex({
                                                  email: typeof email === 'string' ? email : '',
                                                  firstName: '',
                                                  lastName: '',
                                                })
                                              ]?.bg
                                            } ${
                                              colorClasses[
                                                getColorIndex({
                                                  email: typeof email === 'string' ? email : '',
                                                  firstName: '',
                                                  lastName: '',
                                                })
                                              ]?.text
                                            } w-8 h-8 text-[14px] ml-[-5px] rounded-full text-center items-center justify-center flex capitalize  border border-[#fff] [&:nth-child(1)]:-ml-[0px]`}
                                          >
                                            {getInitialsWithDots({
                                              firstName: '',
                                              lastName: '',
                                              email: typeof email === 'string' ? email : '',
                                            })}
                                          </span>
                                        ))}
                                      </div>

                                      {previous.attendeesEmail?.length !== 0 ? (
                                        <div className="flex mt-2"></div>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                  <div className="flex items-end gap-2 justify-between align-middle w-72 items-center">
                                    <div className="relative inline-block text-right w-full">
                                      <button
                                        onClick={() => {
                                          status('closed')
                                          setPreviousMettingId(previous?.id)
                                          setShowDetails(true)

                                          // Update URL to include filter=past and meetingId
                                          try {
                                            const url = new URL(window.location.href)
                                            url.searchParams.set('filter', 'past')
                                            if (previous?.id) {
                                              url.searchParams.set('meetingId', String(previous.id))
                                            } else {
                                              url.searchParams.delete('meetingId')
                                            }
                                            const newUrl = `${url.pathname}${
                                              url.searchParams.toString()
                                                ? `?${url.searchParams.toString()}`
                                                : ''
                                            }`
                                            window.history.pushState({}, '', newUrl)
                                          } catch (e) {
                                            // no-op
                                          }
                                        }}
                                        className={
                                          showDropdown
                                            ? 'inline-flex justify-center text-white items-center px-4 py-2 text-sm font-medium bg-purple rounded-lg hover:bg-gray-300 border border-[#DBDBDB] h-[48px]'
                                            : 'inline-flex justify-center text-black items-center px-4 py-2 text-sm font-medium bg-white rounded-lg hover:bg-gray-300 border border-[#DBDBDB] h-[48px]'
                                        }
                                      >
                                        View details
                                      </button>
                                      {showDropdown && (
                                        <div className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                          <div className="p-1">
                                            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                              <i className="fas fa-clock mr-2"></i>Reschedule
                                              Appointment
                                            </button>
                                            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                              <i className="fas fa-paper-plane mr-2"></i>Request
                                              Reschedule
                                            </button>
                                            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                              <i className="fas fa-user-plus mr-2"></i>Invite People
                                            </button>
                                            <div className="border-t border-grey-darkest"></div>
                                            <button
                                              onClick={() => setShowModal(true)}
                                              className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                                            >
                                              <i className="fas fa-times mr-2"></i>Cancel
                                              Appointment
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {showModal && (
                          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
                            <div className="bg-white w-[400px] max-w-md mx-auto p-6 rounded-[16px] shadow-lg">
                              <div className="relative mb-2 text-center">
                                <div className="w-full text-center inline-block">
                                  <img
                                    alt=""
                                    className="inline-block"
                                    src={require('../../../../appAssets/appImages/Icon.png')}
                                  />
                                </div>
                                <h5 className="text-md font-medium pt-3 text-xl">
                                  Cancel Appointment
                                </h5>
                                <button
                                  onClick={() => setShowModal(false)}
                                  className="text-gray-600 hover:text-gray-900 absolute right-2 top-2"
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                              <p className="text-sm text-gray-600 mb-4 text-center ">
                                Are you sure you want to cancel the appointment?
                              </p>
                              <p className="text-sm text-gray-600 mb-4 text-center ">
                                Please confirm your decision or let them know if you’d like to
                                reschedule.
                              </p>
                              <div className="mb-4 shadow rounded-lg border border-grey-lighter4x p-3">
                                <h6 className="font-medium text-grey-darkest">
                                  Touch Base on Business Plan
                                </h6>
                                <p className="text-sm text-gray-600 pt-1">
                                  May 30, 2024 | 9:00 AM - 9:30 AM CST
                                </p>
                                <div className="flex gap-1 mt-2">
                                  <img
                                    className="w-6 h-6 rounded-full"
                                    src="images/Avatar.png"
                                    alt=""
                                  />
                                  <img
                                    className="w-6 h-6 rounded-full"
                                    src="images/Avatar.png"
                                    alt=""
                                  />
                                  <img
                                    className="w-6 h-6 rounded-full"
                                    src="images/Avatar.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className=" gap-2">
                                <button className="px-4 py-2 bg-purple text-white rounded-lg w-full border border-grey-lighter4x">
                                  Cancel Meeting
                                </button>
                                <button
                                  onClick={() => alert('Reschedule functionality not implemented.')}
                                  className="px-4 py-2 text-black rounded-lg w-full border border-grey-lighter4x mt-1"
                                >
                                  Reschedule Meeting
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </section>
                    </>
                  )
                })
              })()}
            </>
          )}

          {filter.includes('cancelled') && (
            <>
              {meetingDataLoading && (
                <div className="mt-4 space-y-2">
                  <div className="flex justify-center items-center gap-2">
                    <GradientCircleNotchIcon width="100" height="100" />
                  </div>
                </div>
              )}
              {(() => {
                let lastMonth = ''
                return canceledMeetingList.map((canceled) => {
                  const meetingDate = moment.tz(canceled.start, user.timezone).toDate()

                  const day = meetingDate.getDate()
                  const week = meetingDate.toLocaleString('default', { weekday: 'long' })
                  const month = meetingDate.toLocaleString('default', { month: 'long' })
                  const showMonth = month !== lastMonth
                  lastMonth = month
                  const time = canceled.time
                  return (
                    <>
                      <section className="pb-6 font-sans bg-gray-50 text-gray-800 px-5 md:px-0">
                        <div className="mx-auto">
                          <div className="space-y-8">
                            <div>
                              {showMonth && <h6 className="text-lg font-medium mb-4">{month}</h6>}
                              <div className="flex flex-col gap-6">
                                <div
                                  className={
                                    showDropdown
                                      ? 'flex flex-col md:flex-row justify-between items-start p-4 pl-2 rounded-lg border border-grey-lighter4x items-center border-purple'
                                      : 'flex flex-col md:flex-row justify-between items-start p-4 pl-2 bg-white rounded-lg border border-[#ECECEC] items-center'
                                  }
                                >
                                  <div className="flex gap-4">
                                    <div className="text-center w-24 border-e border-[#ECECEC]">
                                      <p className="text-[16px] text-[#71717A] leading-[40px]">
                                        {week.substring(0, 3)}
                                      </p>
                                      <span className="text-[40px] font-medium text-[#71717A] leading-[40px]">
                                        {day}
                                      </span>
                                    </div>
                                    <div className="ps-6">
                                      <h6 className="font-medium flex items-center gap-2 text-md mb-2">
                                        {canceled?.title || 'NA'}
                                      </h6>
                                      <p className="text-sm text-[#5E5E5E]">
                                        {time} {moment().tz(canceled?.timezone).format('z')}
                                      </p>
                                      <div className="flex mt-2">
                                        <span
                                          className={` ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: canceled?.organizerDetail?.firstName,
                                                lastName: canceled?.organizerDetail?.lastName,
                                              })
                                            ]?.bg
                                          } ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: canceled?.organizerDetail?.firstName,
                                                lastName: canceled?.organizerDetail?.lastName,
                                              })
                                            ]?.text
                                          } w-8 h-8 text-[14px] rounded-full  text-center items-center justify-center flex capitalize ml-[-5px] border border-[#fff] [&:nth-child(1)]:-ml-[0px]`}
                                        >
                                          {getInitialsWithDots({
                                            firstName: canceled?.organizerDetail?.firstName,
                                            lastName: canceled?.organizerDetail?.lastName,
                                            email: '',
                                          })}
                                        </span>
                                        <span
                                          className={` ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: canceled?.participantDetail?.firstName,
                                                lastName: canceled?.participantDetail?.lastName,
                                              })
                                            ]?.bg
                                          } ${
                                            colorClasses[
                                              getColorIndex({
                                                email: '',
                                                firstName: canceled?.participantDetail?.firstName,
                                                lastName: canceled?.participantDetail?.lastName,
                                              })
                                            ]?.text
                                          } w-8 h-8 text-[14px] rounded-full  text-center items-center justify-center flex capitalize ml-[-5px]  border border-[#fff] [&:nth-child(1)]:-ml-[0px]`}
                                        >
                                          {getInitialsWithDots({
                                            firstName: canceled?.participantDetail?.firstName,
                                            lastName: canceled?.participantDetail?.lastName,
                                            email: '',
                                          })}
                                        </span>
                                        {[...new Set(canceled?.attendeesEmail)].map((email) => (
                                          <span
                                            className={`${
                                              colorClasses[
                                                getColorIndex({
                                                  email: typeof email === 'string' ? email : '',
                                                  firstName: '',
                                                  lastName: '',
                                                })
                                              ]?.bg
                                            } ${
                                              colorClasses[
                                                getColorIndex({
                                                  email: typeof email === 'string' ? email : '',
                                                  firstName: '',
                                                  lastName: '',
                                                })
                                              ]?.text
                                            } w-8 h-8 text-[14px] ml-[-5px] rounded-full text-center items-center justify-center flex capitalize  border border-[#fff] [&:nth-child(1)]:-ml-[0px]`}
                                          >
                                            {getInitialsWithDots({
                                              firstName: '',
                                              lastName: '',
                                              email: typeof email === 'string' ? email : '',
                                            })}
                                          </span>
                                        ))}
                                      </div>
                                      {canceled.attendeesEmail?.length !== 0 ? (
                                        <div className="flex mt-2"></div>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                  <div className="flex items-end gap-2 justify-between align-middle w-72 items-center">
                                    <div className="relative inline-block text-right w-full">
                                      <button
                                        onClick={() => {
                                          const start = canceled?.start
                                            ? new Date(canceled.start)
                                            : null
                                          const end = canceled?.end ? new Date(canceled.end) : null

                                          const isValidDate = (date: any) =>
                                            date instanceof Date && !isNaN(date.getTime())

                                          const durationMs =
                                            isValidDate(start) && isValidDate(end) && end && start
                                              ? end.getTime() - start.getTime()
                                              : 0

                                          const durationMinute =
                                            durationMs > 0 ? durationMs / (1000 * 60) : 0

                                          setSelectedDuration(durationMinute)
                                          setRescheduleAppointId(canceled)
                                        }}
                                        className={
                                          showDropdown
                                            ? 'inline-flex justify-center text-white items-center px-4 py-2 text-sm font-medium bg-purple rounded-lg hover:bg-gray-300 border border-[#DBDBDB] h-[48px]'
                                            : 'inline-flex justify-center text-black items-center px-4 py-2 text-sm font-medium bg-white rounded-lg hover:bg-gray-300 border border-[#DBDBDB] h-[48px]'
                                        }
                                      >
                                        Reschedule
                                      </button>
                                    </div>
                                  </div>
                                  {rescheduleAppointId && rescheduleAppointId.id === canceled.id && (
                                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                                      <div className="bg-white w-full max-w-lg mx-auto rounded-[16px] shadow-lg">
                                        {/* Header */}
                                        <div className="flex justify-between items-center  p-6 pb-4 relative min-h-[69px]">
                                          {meetingStepper !== MEETING_STEPPER.ADVISOR && (
                                            <div className="flex items-center gap-2">
                                              <img
                                                src={require('../../../../appAssets/appImages/chevron-left.png')}
                                                alt="arrow"
                                                width={20}
                                                onClick={() => {
                                                  dispatch(
                                                    updateMeetingStepperAction({
                                                      actionType: 'decrement',
                                                    })
                                                  )
                                                }}
                                              />
                                              <h2 className="text-lg font-semibold text-[#3F3F46]">
                                                {meetingStepper === MEETING_STEPPER.ADVISOR
                                                  ? 'Schedule Meeting'
                                                  : meetingStepper === MEETING_STEPPER.CALENDAR
                                                  ? 'Select a Date'
                                                  : meetingStepper === MEETING_STEPPER.SLOTS
                                                  ? 'Select a Time'
                                                  : 'Confirm Meeting'}
                                              </h2>
                                            </div>
                                          )}
                                          <button
                                            onClick={() => {
                                              setSelectedClient(null)
                                              setSelectedAdvisor(null)
                                              setRescheduleAppointId([])
                                              dispatch(
                                                updateMeetingStepperAction({
                                                  actionType: 'reset',
                                                  stepName: MEETING_STEPPER.ADVISOR,
                                                })
                                              )

                                              setSelectedDuration(null)
                                            }}
                                            className="text-gray-500 text-end hover:text-gray-700 absolute right-[20px]"
                                          >
                                            <img
                                              src={require('../../../../appAssets/appImages/x-mark.png')}
                                              alt="close"
                                              width={20}
                                            />
                                          </button>
                                        </div>
                                        {meetingStepper === MEETING_STEPPER.ADVISOR && (
                                          <div className="text-left p-6 pt-0">
                                            <h2 className="text-lg font-semibold text-[#121212]">
                                              Request Reschedule
                                            </h2>
                                            {/* Subheading */}
                                            <p className="text-sm text-[#5E5E5E] mb-0">
                                              {`Suggest a new time for "${rescheduleAppointId?.title}" `}
                                            </p>
                                          </div>
                                        )}
                                        <hr className="border-[#ECECEC]" />

                                        {/* Email Input */}
                                        <div
                                          className="text-left p-6"
                                          style={{
                                            display:
                                              meetingStepper === MEETING_STEPPER.ADVISOR
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <h2 className="text-lg font-[700] text-[#3F3F46]">
                                            {meetingStepper === MEETING_STEPPER.ADVISOR &&
                                              'Schedule Meeting'}
                                          </h2>
                                        </div>
                                        <hr className="border-[#ECECEC]" />

                                        {/* Members List */}

                                        <ul className="space-y-4 pt-0 p-6 pb-6">
                                          <div className="text-left sticky">
                                            {meetingStepper === MEETING_STEPPER.ADVISOR && (
                                              <>
                                                <div className="mt-4">
                                                  {!isUserBusinessOwner() ? (
                                                    <>
                                                      <label className="text-sm text-[#3F3F46] font-futura">
                                                        Client
                                                      </label>

                                                      <Select
                                                        styles={{
                                                          control: (base, props) =>
                                                            ({
                                                              ...base,
                                                              border: 'none',
                                                              backgroundColor: '#F4F4F5',
                                                              borderRadius: 10,
                                                              fontFamily: 'Futura Std',
                                                              boxShadow: 'none',
                                                              '&:hover': {
                                                                border: 'none',
                                                              },
                                                            } as CSSObjectWithLabel),
                                                        }}
                                                        classNames={{
                                                          control: (state) =>
                                                            'font-futura text-[16px] font-[700] text-[#18181B] rounded-lg border-0 focus:border-0 h-[48px] mt-1',
                                                        }}
                                                        onChange={handleSelect}
                                                        value={selectedClient}
                                                        placeholder="Search"
                                                        options={list
                                                          ?.filter(
                                                            ({ status }) => status === 'active'
                                                          )
                                                          .map((user) => ({
                                                            ...user,
                                                            fullName: `${user.firstName} ${user.lastName}`,
                                                          }))
                                                          .sort((a, b) =>
                                                            a.fullName.localeCompare(b.fullName)
                                                          )
                                                          .map((user) => {
                                                            return {
                                                              label: `${user.fullName} ${
                                                                user.businessName
                                                                  ? `(${user.businessName})`
                                                                  : ''
                                                              }`,
                                                              value: user,
                                                            }
                                                          })}
                                                        components={
                                                          components
                                                            ? {
                                                                ...components,
                                                                MultiValueRemove,
                                                                DropdownIndicator,
                                                                IndicatorSeparator: () => null,
                                                              }
                                                            : {
                                                                IndicatorSeparator: () => null,
                                                                MultiValueRemove,
                                                                DropdownIndicator,
                                                              }
                                                        }
                                                      />
                                                      <div className="pt-6">
                                                        {selectedClient && (
                                                          <>
                                                            <MeetingDurationTitle className="text-sm text-[#3F3F46] font-futura">
                                                              Select meeting duration
                                                            </MeetingDurationTitle>
                                                            <div className="flex flex-row gap-3 flex-wrap mt-4">
                                                              {timeDurationAvailabilityOptions.map(
                                                                (option) => (
                                                                  <Tile
                                                                    onChange={
                                                                      handleChangeAvailability
                                                                    }
                                                                    value={
                                                                      selectedDuration
                                                                        ? selectedDuration.toString()
                                                                        : ''
                                                                    }
                                                                    label={option.label}
                                                                    optionValue={option.value}
                                                                    className={
                                                                      'w-[127px] !h-[70px]'
                                                                    }
                                                                  />
                                                                )
                                                              )}
                                                            </div>
                                                          </>
                                                        )}
                                                      </div>
                                                      <div>
                                                        {selectedClient &&
                                                          userAvailabilityStatus ===
                                                            availabilityStatus.LOADING && (
                                                            <div className="h-full flex flex-col items-center p-5">
                                                              <GradientCircleNotchIcon
                                                                width="30"
                                                                height="30"
                                                              />
                                                            </div>
                                                          )}
                                                        {selectedClient &&
                                                          userAvailabilityStatus ===
                                                            availabilityStatus.FAILED &&
                                                          flashParams.availabilityConnectionError && (
                                                            <>
                                                              <p className="mt-8">
                                                                {availabilityErrorMessage}
                                                              </p>
                                                              <Button
                                                                className="mt-8 w-full"
                                                                variant="primary"
                                                                label="Send a message"
                                                                onClick={() => {
                                                                  redirectTo(
                                                                    `/${getRoleFromPath()}/${tenantId}/chat`
                                                                  )
                                                                }}
                                                              />
                                                            </>
                                                          )}

                                                        {selectedClient &&
                                                          userAvailabilityStatus ===
                                                            availabilityStatus.SUCCESS && (
                                                            <Button
                                                              label={MEETING_STEPPER.CALENDAR}
                                                              onClick={() =>
                                                                dispatch(
                                                                  updateMeetingStepperAction({
                                                                    actionType: 'increment',
                                                                    stepName:
                                                                      MEETING_STEPPER.CALENDAR,
                                                                  })
                                                                )
                                                              }
                                                              disabled={
                                                                userAvailabilityList?.availability
                                                                  ?.length === 0
                                                              }
                                                              className="w-full"
                                                            />
                                                          )}
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <label className="text-sm text-[#3F3F46] font-futura">
                                                        Advisor
                                                      </label>
                                                      <Select
                                                        styles={{
                                                          control: (base, props) =>
                                                            ({
                                                              ...base,
                                                              border: 'none',
                                                              backgroundColor: '#F4F4F5',
                                                              borderRadius: 10,
                                                              fontFamily: 'Futura Std',
                                                              boxShadow: 'none',
                                                              '&:hover': {
                                                                border: 'none',
                                                              },
                                                            } as CSSObjectWithLabel),
                                                        }}
                                                        classNames={{
                                                          control: (state) =>
                                                            'font-futura text-[16px] font-[700] text-[#18181B] rounded-lg border-0 focus:border-0 h-[48px] mt-1',
                                                        }}
                                                        onChange={handleSelectAdvisor}
                                                        value={selectedAdvisor}
                                                        placeholder="Search"
                                                        options={boAdvisors
                                                          ?.sort((a, b) =>
                                                            a.lastName.localeCompare(b.lastName)
                                                          )
                                                          .map((user) => {
                                                            return {
                                                              label: `${user.firstName} ${user.lastName}`,
                                                              value: user,
                                                            }
                                                          })}
                                                        components={
                                                          components
                                                            ? {
                                                                ...components,
                                                                MultiValueRemove,
                                                                DropdownIndicator,
                                                                IndicatorSeparator: () => null,
                                                              }
                                                            : {
                                                                IndicatorSeparator: () => null,
                                                                MultiValueRemove,
                                                                DropdownIndicator,
                                                              }
                                                        }
                                                      />
                                                      <MeetingDuration>
                                                        {isAvailabilityHoursLoading && (
                                                          <div className="h-full flex flex-col items-center">
                                                            <GradientCircleNotchIcon
                                                              width="80"
                                                              height="80"
                                                            />
                                                          </div>
                                                        )}
                                                        {selectedAdvisor &&
                                                          !isAvailabilityHoursLoading && (
                                                            <Fragment>
                                                              <MeetingDurationTitle className="font-futura">
                                                                Select meeting duration
                                                              </MeetingDurationTitle>
                                                              <div className="flex flex-row gap-3 flex-wrap">
                                                                {durationOptions.map((option) => (
                                                                  <Tile
                                                                    onChange={
                                                                      handleChangeAvailabilityAdvisor
                                                                    }
                                                                    value={
                                                                      selectedDuration
                                                                        ? selectedDuration.toString()
                                                                        : ''
                                                                    }
                                                                    label={option.label}
                                                                    optionValue={option.value}
                                                                    className={
                                                                      'w-[127px] !h-[70px]'
                                                                    }
                                                                  />
                                                                ))}
                                                              </div>
                                                            </Fragment>
                                                          )}
                                                        {selectedAdvisor &&
                                                          userAvailabilityStatus ===
                                                            availabilityStatus.SUCCESS &&
                                                          !isAvailabilityHoursLoading &&
                                                          !isEmpty(
                                                            userAvailabilityList?.availability
                                                          ) && (
                                                            <Button
                                                              label="Select a Date"
                                                              onClick={() =>
                                                                dispatch(
                                                                  updateMeetingStepperAction({
                                                                    actionType: 'increment',
                                                                    stepName:
                                                                      MEETING_STEPPER.CALENDAR,
                                                                  })
                                                                )
                                                              }
                                                              disabled={isEmpty(
                                                                userAvailabilityList?.availability
                                                              )}
                                                              className="w-full"
                                                            />
                                                          )}
                                                        {selectedDuration !== null &&
                                                          selectedDuration !== undefined &&
                                                          selectedDuration.toString() &&
                                                          userAvailabilityStatus ===
                                                            availabilityStatus.LOADING && (
                                                            <div className="h-full flex flex-col items-center p-5">
                                                              <GradientCircleNotchIcon
                                                                width="30"
                                                                height="30"
                                                              />
                                                            </div>
                                                          )}
                                                        {isError && (
                                                          <Fragment>
                                                            <p>{availabilityErrorMessageAdvisor}</p>
                                                            <Button
                                                              className="mt-8 w-full"
                                                              variant="primary"
                                                              label="Send a message"
                                                              onClick={() => {
                                                                redirectTo(
                                                                  `/owner/${tenantId}/chat`
                                                                )
                                                              }}
                                                            />
                                                          </Fragment>
                                                        )}
                                                      </MeetingDuration>
                                                    </>
                                                  )}
                                                </div>
                                              </>
                                            )}

                                            {/* CALENDAR */}
                                            <div>
                                              {meetingStepper === MEETING_STEPPER.CALENDAR && (
                                                <div className="h-[500px] overflow-auto mt-6">
                                                  <div>
                                                    <div className="text-[#3F3F46] text-md font-[500] font-futura">
                                                      {participantLabel}
                                                    </div>
                                                    <div className="text-[#18181B] text-md font-[700] border-b border-[#ECECEC] py-4 font-futura">
                                                      {participantName?.value?.firstName}{' '}
                                                      {participantName?.value?.lastName}
                                                    </div>
                                                  </div>
                                                  <div className="text-[#18181B] text-md font-[700] border-b border-[#ECECEC] py-4 font-futura">
                                                    {selectedDuration} min meeting
                                                  </div>

                                                  {!isBusinessOwner && (
                                                    <CheckboxWrapper>
                                                      <Controller
                                                        name="ignoreConflicts"
                                                        control={control}
                                                        render={({ field }) => (
                                                          <CheckBoxField
                                                            {...field}
                                                            id=""
                                                            className="!gap-2 !pr-0"
                                                            onChange={(value) => {
                                                              field.onChange(value)
                                                              handleChangeConflicts(value)
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                      <span className="text font-futura">
                                                        {userRole === ROLES.BUSINESS_OWNER
                                                          ? 'Ignore scheduling conflicts with my calendar'
                                                          : 'Ignore scheduling conflicts'}{' '}
                                                      </span>
                                                    </CheckboxWrapper>
                                                  )}
                                                  <CalendarTitle>Select Date:</CalendarTitle>
                                                  <div>
                                                    {userAvailabilityStatus ===
                                                    availabilityStatus.LOADING ? (
                                                      <div className="flex justify-center">
                                                        <GradientCircleNotchIcon
                                                          width="100"
                                                          height="100"
                                                        />
                                                      </div>
                                                    ) : (
                                                      <CalendarWrapper>
                                                        <Calendar
                                                          view="month"
                                                          showFixedNumberOfWeeks={true}
                                                          formatDay={(_, date) =>
                                                            moment(date).local().format('DD')
                                                          }
                                                          formatShortWeekday={(_, date) =>
                                                            moment(date).local().format('ddd')
                                                          }
                                                          className="!w-full "
                                                          onChange={handleCalendarChange}
                                                          value={calendarDate}
                                                          tileClassName={(props) =>
                                                            getTileClassName({
                                                              ...props,
                                                              userAvailabilityList,
                                                            })
                                                          }
                                                          onClickDay={handleTileClick}
                                                          locale="en-US"
                                                          onActiveStartDateChange={
                                                            refreshAdvisorAvailability
                                                          }
                                                        />
                                                      </CalendarWrapper>
                                                    )}
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                            {/* SLOTS */}
                                            {meetingStepper === MEETING_STEPPER.SLOTS &&
                                              userAvailabilityStatus === 'loading' && (
                                                <div className="col-span-12 flex flex-row justify-center p-12">
                                                  <CircleNotchIcon
                                                    className={'fill-primary'}
                                                    width="63"
                                                    height="66"
                                                  />
                                                </div>
                                              )}
                                            {meetingStepper === MEETING_STEPPER.SLOTS &&
                                              isEmpty(availableSlots) &&
                                              userAvailabilityStatus !== 'loading' && (
                                                <NoSlotLabel>
                                                  Sorry, No Slots Available on this Day
                                                </NoSlotLabel>
                                              )}

                                            {meetingStepper === MEETING_STEPPER.SLOTS &&
                                              !isEmpty(availableSlots) && (
                                                <div className="pt-6">
                                                  <div className="text-[#18181B] text-[20px] font-[500] font-futura">
                                                    {formattedDate}
                                                  </div>
                                                  <TimeDuration>
                                                    <div className="mt-4">
                                                      <p className="font-[500] text-md text-[#3F3F46] mb-4 font-futura">
                                                        Time Zone:
                                                      </p>{' '}
                                                      <p className="text-[#5E06B9] text-md font-[700]">
                                                        {getTimeZoneDisplayRepresentation(
                                                          user?.timezone ?? moment.tz.guess()
                                                        )}{' '}
                                                        ({currentTime})
                                                      </p>
                                                    </div>
                                                  </TimeDuration>
                                                  <TimeDuration>
                                                    <div className="font-[500] text-md text-[#3F3F46] border-b border-[#ECECEC] pb-4">
                                                      Meeting Duration:{' '}
                                                      {`${userAvailabilityList?.duration} minutes`}{' '}
                                                    </div>
                                                  </TimeDuration>

                                                  {/* <Divider /> */}
                                                  <div className="mt-0 mb-3 font-futura">
                                                    Select a time:
                                                  </div>
                                                  <div className="h-[300px] overflow-auto">
                                                    {isBusinessOwner ? (
                                                      <div className="h-[300px] overflow-hidden">
                                                        <SlotsSelector
                                                          availableSlots={availableSlots}
                                                          onClick={(slot) => {
                                                            setSelectedSlot(slot)
                                                            dispatch(
                                                              updateMeetingStepperAction({
                                                                actionType: 'increment',
                                                                stepName:
                                                                  MEETING_STEPPER.DESCRIPTION,
                                                              })
                                                            )
                                                          }}
                                                        />
                                                      </div>
                                                    ) : (
                                                      <PaginatedSlots
                                                        slots={availableSlots}
                                                        date={selectedDate}
                                                        onClick={(event) => {
                                                          setSelectedSlot(event)
                                                          dispatch(
                                                            updateMeetingStepperAction({
                                                              actionType: 'increment',
                                                              stepName: MEETING_STEPPER.DESCRIPTION,
                                                            })
                                                          )
                                                        }}
                                                      />
                                                    )}
                                                  </div>
                                                </div>
                                              )}

                                            {meetingStepper === MEETING_STEPPER.DESCRIPTION && (
                                              <div className="pt-4">
                                                <IconWithLabel>
                                                  <CalendarIcon
                                                    className={'inline mr-3 fill-primary-text'}
                                                  />
                                                  <span className="font-[400] text-[18px] text-[#18181B] font-futura">
                                                    {formattedDate}
                                                  </span>
                                                </IconWithLabel>
                                                <div className=" border-b border-[#ECECEC] mt-4 pb-4">
                                                  {selectedSlot && (
                                                    <IconWithLabel>
                                                      <ClockIcon
                                                        className={
                                                          'inline mr-3 fill-primary-disabled hover:!fill-primary-disabled'
                                                        }
                                                      />
                                                      <div className="flex flex-col">
                                                        <span className="text-[18px] font-normal text-[#18181B] font-futura">
                                                          {selectedSlot.slotStartTime} -{' '}
                                                          {selectedSlot.slotEndTime}
                                                        </span>
                                                        <p className="text-[18px] font-normal text-[#18181B] font-futura">
                                                          ({user.timezone})
                                                        </p>
                                                      </div>
                                                    </IconWithLabel>
                                                  )}
                                                </div>
                                                {/* <Divider /> */}
                                                <div className="h-[400px] overflow-auto font-futura">
                                                  <InputFieldsWrapper>
                                                    <MeetingDetails
                                                      event={rescheduleAppointId}
                                                      selectedUser={participantName?.value!}
                                                      isEdit={false}
                                                      onSubmit={onSubmitRescheduleCancel}
                                                      isDisabled={isRescheduleMeetingLoading}
                                                      description={meetingDescription}
                                                      setDescription={setMeetingDescription}
                                                      updateMeetingStepperAction={
                                                        updateMeetingStepperAction
                                                      }
                                                      videoLinkDescription={
                                                        advisorProfile?.defaultVideoLinkDescription ??
                                                        user?.defaultVideoLinkDescription ??
                                                        ''
                                                      }
                                                      user={user}
                                                      userAvailableMeetingLocation={
                                                        userAvailableMeetingLocation
                                                      }
                                                      methods={methods}
                                                    />
                                                  </InputFieldsWrapper>
                                                </div>
                                              </div>
                                            )}
                                            {meetingStepper ===
                                              MEETING_STEPPER.MEETING_CONFIRMATION &&
                                              selectedAdvisor && (
                                                <MeetingConfirmationContainer
                                                  labelText=""
                                                  handleClose={handleClose}
                                                  errorMessage={error}
                                                  successMessage={successMessage}
                                                />
                                              )}
                                          </div>
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </>
                  )
                })
              })()}
            </>
          )}
        </>
      )}
    </div>
  )
}

export default UpcomingMeeting
